export default {
    // 中
    zhCN: {
        vin: 'VIN',
        claim_information: '索赔信息',
        marketing_activity_list: '营销活动列表',
        basic_information: '基础信息',
        warranty_block: '保修块',
        repair_block_code: '保修块代码',
        claim_cycle_list: '索赔周期列表',
        WTY_Indicates_the_cycle_type: 'WTY周期类型',
        start_time: '开始时间',
        end_time: '结束时间',
        WTY_mileage: 'WTY里程',
        List_of_claims: '索赔单列表',
        customer: '顾客',
        warranty_claim: '保修索赔单',
        work_order: '工单',
        date_of_receipt: '接收日期',
        maintenance_technical_date: '维修技术日期',
        mileage: '里程',
        state: '状态',
        main_component: '主要部件',
        part_name: '零件名称',
        Recall_and_service_activities: '召回和服务活动',
        recall_and_service_activity_code: '召回和服务活动代码',
        recall_and_service_activity_names: '召回和服务活动名称',
        brand: '品牌',
        recall_type_code: '服务类型代码',
        recall_type_name: '服务类型名称',
        release_date: '发布日期',
        closing_date: '关闭日期',
        complete: '完成',
        warranty_claim_status: '保修索赔状态',
        end_of_maintenance_date: '维修结束日期',
        marketing_activity_code: '市场活动代码',
        marketing_activity_name: '市场活动名称',
        vehicle_warranty_period: '车辆质保期',
        marketing_activities: '市场活动',
        prohibition_of_claims: '禁止索赔',
        prohibited_claim_code: '禁止索赔代码',
        type_of_warranty_period: '质保期类型',
        repair_end_date: '维修结束日期',
        reception_date: '接待日期',
        main_station_code: '主工位代码',
        main_workstation_name: '主工位名称',
        smvp_initiator: 'SMPV发起人',
        contact_email: 'SMPV联系邮箱',
        ssnw_doc_no: 'SSNW单据号',
        gws_doc_no: 'GWS单据号',
        missing_doc_reason: '单据号缺失原因',
        part_return_no: '零件回运单号',
        part_price: '零件价格($)',
        return_info: '回运信息',
        add_part: '添加零件',
        initiate_part_return: '发起零件回运',
        domestic_return_form: '国内回运单',
        confirm_part_received: '确认零件签收',
        submit_analysis_report: '分析报告提交',
        fill_domestic_return_form: '国内回运单填写',
        view_overseas_return_info: '回运单信息查看',
        confirm_domestic_part_return: '确认国内零件回运',
        issue: '下发',
        fill_overseas_return_form: '回运单填写',
        confirm_overseas_part_return: '确认零件回运',
        view_overseas_return_form: '回运单查看',
        reject_reason: '拒绝原因',
        choose_part: '选择零件',
        express_tracking_number: '快递单号',
        auditor: '审核人',
        recipient: '下发对象',
        pickup_date: '快递取件日期',
        consignee: '收货人',
        consignee_company: '收货人公司',
        delivery_address: '收货地址',
        consignee_phone: '收货人电话',
        shipper: '发货人',
        shipper_company: '发货人公司',
        address: '住址',
        country_of_origin: '原产国',
        total_price: '总价($)',
        analysis_rejection_reason: '分析结果拒绝原因',
        export_invoice: '导出发票',
        dhl_confirm_auth: 'DHL确认授权',
        reject_return_warning: '拒绝回运可能会扣除索赔款',
        use_consignee_account_tip: '使用收件方账号寄件需对方授权，请提供寄件用邮箱',
    },
    // 英
    enUS: {
        vin: 'VIN',
        claim_information: 'Claim information',
        marketing_activity_list: 'Marketing campaign',
        basic_information: 'Basic information',
        warranty_block: 'Warranty block',
        repair_block_code: 'Warranty block code',
        claim_cycle_list: 'WTY period list',
        WTY_Indicates_the_cycle_type: 'WTY period type',
        start_time: 'Start date',
        end_time: 'End date',
        WTY_mileage: 'WTY mileage',
        List_of_claims: 'WTY history',
        customer: 'Customer',
        warranty_claim: 'Warranty claim',
        work_order: 'Work order',
        date_of_receipt: 'Reception date',
        maintenance_technical_date: 'Repair date',
        mileage: 'Mileage',
        state: 'Status',
        main_component: 'Main part',
        part_name: 'Part name_en',
        Recall_and_service_activities: 'Recall&service campaign',
        recall_and_service_activity_code: 'Recall&service campaign code',
        recall_and_service_activity_names: 'Recall&service campaign name',
        brand: 'Brand',
        recall_type_code: 'Recall type code',
        recall_type_name: 'Recall type name',
        release_date: 'Release date',
        closing_date: 'Close date',
        complete: 'Completed',
        warranty_claim_status: 'Warranty claim status',
        end_of_maintenance_date: 'End date of last repair',
        marketing_activity_code: 'Marketing campaign code',
        marketing_activity_name: 'Marketing campaign name',
        vehicle_warranty_period: 'Vehicle warranty period',
        marketing_activities: 'Marketing activities',
        prohibition_of_claims: 'Prohibition of claims',
        prohibited_claim_code: 'Prohibited claim code',
        type_of_warranty_period: 'Type of warranty period',
        repair_end_date: 'Repair end date',
        reception_date: 'Reception date',
        main_station_code: 'Main station code',
        main_workstation_name: 'Main workstation name',
        smvp_initiator: 'SMPV Initiator',
        contact_email: 'SMPV Contact Email',
        ssnw_doc_no: 'SSNW Document Number',
        gws_doc_no: 'GWS Document Number',
        missing_doc_reason: 'Reason for Missing Document Number',
        part_return_no: 'Part Return Number',
        part_price: 'Part Price($)',
        return_info: 'Return Info',
        add_part: 'Add Part',
        initiate_part_return: 'Initiate Return',
        domestic_return_form: 'Domestic Return Form',
        confirm_part_received: 'Confirm Receipt',
        submit_analysis_report: 'Submit Report',
        fill_domestic_return_form: 'Fill Domestic Form',
        view_overseas_return_info: 'View Info',
        confirm_domestic_part_return: 'Confirm Domestic Return',
        issue: 'Assign',
        fill_overseas_return_form: 'Fill Form',
        confirm_overseas_part_return: 'Confirm Return',
        view_overseas_return_form: 'View Form',
        reject_reason: 'Reject Reason',
        choose_part: 'Select Part',
        express_tracking_number: 'Express Tracking Number',
        auditor: 'Auditor',
        recipient: 'Recipient',
        pickup_date: 'Pickup Date',
        consignee: 'Consignee',
        consignee_company: 'Consignee Company',
        delivery_address: 'Delivery Address',
        consignee_phone: 'Consignee Phone',
        shipper: 'Shipper',
        shipper_company: 'Shipper Company',
        address: 'Address',
        country_of_origin: 'Country of Origin',
        total_price: 'Total Price($)',
        analysis_rejection_reason: 'Reason for Rejection of Analysis Result',
        export_invoice: 'Export Invoice',
        dhl_confirm_auth: 'Confirm DHL Authorization',
        reject_return_warning:
            'Rejecting the return may result in a deduction from your claim amount.',
        use_consignee_account_tip:
            'Using the consignee\'s account for shipping requires their authorization. Please provide the email to be used for shipping.',
    },
    // 德
    deDE: {
        vin: 'VIN',
        claim_information: 'Schadensinformation',
        marketing_activity_list: 'Marketing-Kampagnenliste',
        basic_information: 'Grundinformationen',
        warranty_block: 'Garantieblock',
        repair_block_code: 'Garantie-Blockcode',
        claim_cycle_list: 'WTY-Zeitraum Liste',
        WTY_Indicates_the_cycle_type: 'WTY-Zeitraumtyp',
        start_time: 'Startzeit',
        end_time: 'Endzeit',
        WTY_mileage: 'WTY-Kilometerstand',
        List_of_claims: 'WTY-Verlauf',
        customer: 'Kunde',
        warranty_claim: 'Garantieanspruch',
        work_order: 'Arbeitsauftrag',
        date_of_receipt: 'Empfangsdatum',
        maintenance_technical_date: 'Wartungsdatum',
        mileage: 'Kilometerstand',
        state: 'Status',
        main_component: 'Hauptkomponente',
        part_name: 'Teilname',
        Recall_and_service_activities: 'Rückruf & Service-Kampagne',
        recall_and_service_activity_code: 'Rückruf & Service-Kampagnencode',
        recall_and_service_activity_names: 'Rückruf & Service-Kampagnenname',
        brand: 'Marke',
        recall_type_code: 'Diensttypcode',
        recall_type_name: 'Name des Diensttyps',
        release_date: 'Veröffentlichungsdatum',
        closing_date: 'Abschlussdatum',
        complete: 'vollständig',
        warranty_claim_status: 'Garantieanspruchstatus',
        end_of_maintenance_date: 'Enddatum der letzten Reparatur',
        marketing_activity_code: 'Kampagnencode',
        marketing_activity_name: 'Kampagnenname',
        vehicle_warranty_period: 'Garantiezeit für Fahrzeuge',
        marketing_activities: 'Marketingaktivitäten',
        prohibition_of_claims: 'Verbot von Ansprüchen',
        prohibited_claim_code: 'Code für verbotene Ansprüche',
        type_of_warranty_period: 'Art der Garantiezeit',
        repair_end_date: 'Enddatum der Reparatur',
        reception_date: 'Empfangsdatum',
        main_station_code: 'Hauptbahnhofcode',
        main_workstation_name: 'Name des Hauptplatzes',
        smvp_initiator: 'SMPV-Initiator',
        contact_email: 'E-Mail des SMPV-Kontakts',
        ssnw_doc_no: 'SSNW-Dokumentennummer',
        gws_doc_no: 'GWS-Dokumentennummer',
        missing_doc_reason: 'Grund für fehlende Dokumentennummer',
        part_return_no: 'Teile-Rückgabenummer',
        part_price: 'Teilepreis($)',
        return_info: 'Rücksendeinformationen',
        add_part: 'Teil hinzufügen',
        initiate_part_return: 'Rücksendung initiieren',
        domestic_return_form: 'Inländisches Rücksendeformular',
        confirm_part_received: 'Empfang bestätigen',
        submit_analysis_report: 'Bericht einreichen',
        fill_domestic_return_form: 'Inländisches Formular ausfüllen',
        view_overseas_return_info: 'Rücksendeinfo anzeigen',
        confirm_domestic_part_return: 'Inländische Rücksendung bestätigen',
        issue: 'Zuweisen',
        fill_overseas_return_form: 'Formular ausfüllen',
        confirm_overseas_part_return: 'Rücksendung bestätigen',
        view_overseas_return_form: 'Formular anzeigen',
        reject_reason: 'Ablehnungsgrund',
        choose_part: 'Bauteil auswählen',
        express_tracking_number: 'Express Sendungsnummer',
        auditor: 'Prüfer',
        recipient: 'Empfänger',
        pickup_date: 'Abholdatum',
        consignee: 'Empfänger',
        consignee_company: 'Empfängerfirma',
        delivery_address: 'Lieferadresse',
        consignee_phone: 'Telefon des Empfängers',
        shipper: 'Absender',
        shipper_company: 'Absenderfirma',
        address: 'Adresse',
        country_of_origin: 'Herkunftsland',
        total_price: 'Gesamtpreis($)',
        analysis_rejection_reason: 'Ablehnungsgrund für das Analyseergebnis',
        export_invoice: 'Rechnung exportieren',
        dhl_confirm_auth: 'DHL-Berechtigung bestätigen',
        reject_return_warning:
            'Die Ablehnung der Rücksendung kann zu einem Abzug vom Schadensersatzbetrag führen.',
        use_consignee_account_tip:
            'Für den Versand über das Empfängerkonto ist eine Autorisierung erforderlich. Bitte geben Sie die zu verwendende E-Mail-Adresse an.',
    },
    // 法
    frFR: {
        vin: 'VIN',
        claim_information: 'Informations sur les réclamations',
        marketing_activity_list: 'Campagne de marketing',
        basic_information: 'Informations de base',
        warranty_block: 'Bloc garantie',
        repair_block_code: 'Code de bloc garantie',
        claim_cycle_list: 'Liste des périodes de garantie',
        WTY_Indicates_the_cycle_type: 'Types de périodes de garantie',
        start_time: 'Date de début',
        end_time: 'Date de fin',
        WTY_mileage: 'kilométrage garantie',
        List_of_claims: 'Histortique garantie',
        customer: 'Client',
        warranty_claim: 'Demande de garantie',
        work_order: 'Ordre de réparation',
        date_of_receipt: 'Date de réception',
        maintenance_technical_date: 'Date de fin de travaux',
        mileage: 'Kilométrage',
        state: 'Statut',
        main_component: 'Pièce principale',
        part_name: 'Nom de pièce',
        Recall_and_service_activities: 'Campagnes de rappel de service',
        recall_and_service_activity_code: 'Code campagne',
        recall_and_service_activity_names: 'Nom campagne',
        brand: 'Marque',
        recall_type_code: 'Code du type de service',
        recall_type_name: 'Nom du type de service',
        release_date: 'Date d\'ouverture',
        closing_date: 'Date de fermeture',
        complete: 'Effectuée',
        warranty_claim_status: 'Statut de la demande de garantie',
        end_of_maintenance_date: 'Date de fin de travaux',
        marketing_activity_code: 'Code de campagne marketing',
        marketing_activity_name: 'Nom de l’activité marketing',
        smvp_initiator: 'Initiateur du SMPV',
        contact_email: 'E-mail de contact SMPV',
        ssnw_doc_no: 'Numéro de document SSNW',
        gws_doc_no: 'Numéro de document GWS',
        missing_doc_reason: 'Raison du numéro de document manquant',
        part_return_no: 'Numéro de retour de pièce',
        part_price: 'Prix de la pièce($)',
        return_info: 'Informations sur le retour',
        add_part: 'Ajouter une pièce',
        initiate_part_return: 'Initier un retour',
        domestic_return_form: 'Formulaire de retour national',
        confirm_part_received: 'Confirmer la réception',
        submit_analysis_report: 'Soumettre le rapport',
        fill_domestic_return_form: 'Remplir formulaire national',
        view_overseas_return_info: 'Voir info retour',
        confirm_domestic_part_return: 'Confirmer retour national',
        issue: 'Envoyer',
        fill_overseas_return_form: 'Remplir formulaire',
        confirm_overseas_part_return: 'Confirmer retour',
        view_overseas_return_form: 'Voir formulaire',
        reject_reason: 'Motif du refus',
        choose_part: 'Sélectionner une pièce',
        express_tracking_number: 'Numéro de suivi express',
        auditor: 'Auditeur',
        recipient: 'Destinataire',
        pickup_date: 'Date de ramassage',
        consignee: 'Destinataire',
        consignee_company: 'Société du destinataire',
        delivery_address: 'Adresse de livraison',
        consignee_phone: 'Téléphone du destinataire',
        shipper: 'Expéditeur',
        shipper_company: 'Société de l\'expéditeur',
        address: 'Adresse',
        country_of_origin: 'Pays d\'origine',
        total_price: 'Prix total($)',
        analysis_rejection_reason: 'Raison du refus du résultat d\'analyse',
        export_invoice: 'Exporter la facture',
        dhl_confirm_auth: 'Confirmer l\'autorisation DHL',
        reject_return_warning:
            'Refuser le retour peut entraîner une déduction sur le montant de votre réclamation.',
        use_consignee_account_tip:
            'L’utilisation du compte du destinataire pour l’expédition nécessite son autorisation. Veuillez fournir l’adresse e-mail à utiliser.',
    },
    // 意大利
    itIT: {
        vin: 'VIN',
        claim_information: 'Informazioni reclamo',
        marketing_activity_list: 'Campagna di marketing',
        basic_information: 'Informazioni di base',
        warranty_block: 'Blocco garanzia',
        repair_block_code: 'Codice blocco garanzia',
        claim_cycle_list: 'Elenco periodi garanzia',
        WTY_Indicates_the_cycle_type: 'Tipo di periodo garanzia',
        start_time: 'Ora di inizio',
        end_time: 'Ora di fine',
        WTY_mileage: 'Kilometraggio garanzia',
        List_of_claims: 'Storico garanzia',
        customer: 'Cliente',
        warranty_claim: 'Reclamo garanzia',
        work_order: 'Ordine di lavoro',
        date_of_receipt: 'Data di ricezione',
        maintenance_technical_date: 'Data di riparazione',
        mileage: 'Chilometraggio',
        state: 'Stato',
        main_component: 'Componente principale',
        part_name: 'Nome parte',
        Recall_and_service_activities: 'Campagna richiami e servizio',
        recall_and_service_activity_code: 'Codice campagna richiami e servizio',
        recall_and_service_activity_names: 'Nome campagna richiami e servizio',
        brand: 'Marchio',
        recall_type_code: 'Codice tipo di servizio',
        recall_type_name: 'Nome del tipo di servizio',
        release_date: 'Data di rilascio',
        closing_date: 'Data di chiusura',
        complete: 'Completa',
        warranty_claim_status: 'Stato reclamo garanzia',
        end_of_maintenance_date: 'Data di fine dell\'ultima riparazione',
        marketing_activity_code: 'Codici delle attività di mercato',
        marketing_activity_name: 'Nome dell’attività commerciale',
        vehicle_warranty_period: 'Periodo di garanzia del veicolo',
        marketing_activities: 'Attività di marketing',
        prohibition_of_claims: 'Divieto di rivendicazioni',
        prohibited_claim_code: 'Codice delle richieste vietate',
        type_of_warranty_period: 'Tipo di periodo di garanzia',
        repair_end_date: 'Data di fine riparazione',
        reception_date: 'Data di ricevimento',
        main_station_code: 'Codice della stazione centrale',
        main_workstation_name: 'Nome della stazione di lavoro principale',
        smvp_initiator: 'Iniziatore del SMPV',
        contact_email: 'Email di contatto SMPV',
        ssnw_doc_no: 'Numero documento SSNW',
        gws_doc_no: 'Numero documento GWS',
        missing_doc_reason: 'Motivo del numero documento mancante',
        part_return_no: 'Numero di reso del ricambio',
        part_price: 'Prezzo del ricambio($)',
        return_info: 'Informazioni reso',
        add_part: 'Aggiungi ricambio',
        initiate_part_return: 'Avvia reso',
        domestic_return_form: 'Modulo reso nazionale',
        confirm_part_received: 'Conferma ricezione',
        submit_analysis_report: 'Invia rapporto',
        fill_domestic_return_form: 'Compila modulo nazionale',
        view_overseas_return_info: 'Visualizza info',
        confirm_domestic_part_return: 'Conferma reso nazionale',
        issue: 'Emetti',
        fill_overseas_return_form: 'Compila modulo',
        confirm_overseas_part_return: 'Conferma reso',
        view_overseas_return_form: 'Visualizza modulo',
        reject_reason: 'Motivo del rifiuto',
        choose_part: 'Seleziona parte',
        express_tracking_number: 'Numero di tracking espresso',
        auditor: 'Revisore',
        recipient: 'Destinatario',
        pickup_date: 'Data di ritiro',
        consignee: 'Destinatario',
        consignee_company: 'Azienda del destinatario',
        delivery_address: 'Indirizzo di consegna',
        consignee_phone: 'Telefono del destinatario',
        shipper: 'Speditore',
        shipper_company: 'Azienda dello speditore',
        address: 'Indirizzo',
        country_of_origin: 'Paese di origine',
        total_price: 'Prezzo totale($)',
        analysis_rejection_reason: 'Motivo del rifiuto del risultato dell\'analisi',
        export_invoice: 'Esporta fattura',
        dhl_confirm_auth: 'Conferma autorizzazione DHL',
        reject_return_warning:
            'Rifiutare il reso potrebbe comportare una detrazione dall’importo del rimborso richiesto.',
        use_consignee_account_tip:
            'Per spedire con il conto del destinatario è necessaria la sua autorizzazione. Fornisci l’indirizzo email da utilizzare per la spedizione.',
    },
    // 荷兰
    nlNL: {
        vin: 'VIN',
        claim_information: 'Claim informatie',
        marketing_activity_list: 'Marketingcampagne',
        basic_information: 'Basisinformatie',
        warranty_block: 'Garantieblokkering',
        repair_block_code: 'Code garantieblokkering',
        claim_cycle_list: 'Garantieperiodelijst',
        WTY_Indicates_the_cycle_type: 'WTY-periode type',
        start_time: 'Starttijd',
        end_time: 'Eindtijd',
        WTY_mileage: 'WTY kilometerstand',
        List_of_claims: 'WTY-geschiedenis',
        customer: 'Klant',
        warranty_claim: 'Garantieclaim',
        work_order: 'Werkorder',
        date_of_receipt: 'Ontvangst datum',
        maintenance_technical_date: 'Reparatiedatum',
        mileage: 'kilometerstand',
        state: 'Status',
        main_component: 'Hoofdonderdeel',
        part_name: 'Onderdeelnaam',
        Recall_and_service_activities: 'Terugroep- & servicecampagne',
        recall_and_service_activity_code: 'Terugroep- & servicecampagnecode',
        recall_and_service_activity_names: 'Terugroep- & servicecampagnenaam',
        brand: 'Merk',
        recall_type_code: 'Code van het diensttype',
        recall_type_name: 'Diensttype naam',
        release_date: 'Releasedatum',
        closing_date: 'Sluitingsdatum',
        complete: 'voltooid',
        warranty_claim_status: 'Garantieclaim status',
        end_of_maintenance_date: 'Einddatum van laatste reparatie',
        marketing_activity_code: 'Code voor marktactiviteiten',
        marketing_activity_name: 'Naam van de marktactiviteiten',
        vehicle_warranty_period: 'Garantieperiode voor voertuigen',
        marketing_activities: 'Marketingactiviteiten',
        prohibition_of_claims: 'Verbod op vorderingen',
        prohibited_claim_code: 'Code verboden claims',
        type_of_warranty_period: 'Soort garantieperiode',
        repair_end_date: 'inddatum herstellen',
        reception_date: 'Ontvangstdatum',
        main_station_code: 'Code van het hoofdstation',
        main_workstation_name: 'Naam hoofdwerkstation',
        smvp_initiator: 'SMPV-initiator',
        contact_email: 'SMPV-contactemail',
        ssnw_doc_no: 'Documentnummer SSNW',
        gws_doc_no: 'Documentnummer GWS',
        missing_doc_reason: 'Reden voor ontbrekend documentnummer',
        part_return_no: 'Onderdeel retournummer',
        part_price: 'Onderdeelprijs($)',
        return_info: 'Retourinformatie',
        add_part: 'Onderdeel toevoegen',
        initiate_part_return: 'Retour starten',
        domestic_return_form: 'Nationaal retourformulier',
        confirm_part_received: 'Ontvangst bevestigen',
        submit_analysis_report: 'Rapport indienen',
        fill_domestic_return_form: 'Nationaal formulier invullen',
        view_overseas_return_info: 'Bekijk retourinfo',
        confirm_domestic_part_return: 'Bevestig nationale retour',
        issue: 'Uitgeven',
        fill_overseas_return_form: 'Formulier invullen',
        confirm_overseas_part_return: 'Bevestig retour',
        view_overseas_return_form: 'Bekijk formulier',
        reject_reason: 'Reden van weigering',
        choose_part: 'Onderdeel selecteren',
        express_tracking_number: 'Express trackingsnummer',
        auditor: 'Controleur',
        recipient: 'Ontvanger',
        pickup_date: 'Ophaaldatum',
        consignee: 'Geadresseerde',
        consignee_company: 'Bedrijf van geadresseerde',
        delivery_address: 'Afleveradres',
        consignee_phone: 'Telefoon geadresseerde',
        shipper: 'Afzender',
        shipper_company: 'Bedrijf van afzender',
        address: 'Adres',
        country_of_origin: 'Land van herkomst',
        total_price: 'Totaalprijs($)',
        analysis_rejection_reason: 'Reden voor afwijzing van analyseresultaat',
        export_invoice: 'Factuur exporteren',
        dhl_confirm_auth: 'Bevestig DHL-machtiging',
        reject_return_warning:
            'Het weigeren van het retour kan leiden tot een inhouding op het schadebedrag.',
        use_consignee_account_tip:
            'Verzenden via het account van de ontvanger vereist diens toestemming. Geef het te gebruiken e-mailadres op.',
    },
    // 越南
    viVN: {
        vin: 'Số khung',
        claim_information: 'Thông tin đòi lại',
        marketing_activity_list: 'Chiến dịch marketing',
        basic_information: 'Thông tin cơ bản',
        warranty_block: 'Khối bảo hành',
        repair_block_code: 'Mã khối bảo hành',
        claim_cycle_list: 'Danh sách thời gian bảo hành',
        WTY_Indicates_the_cycle_type: 'Loại thời gian bảo hành',
        start_time: 'Ngày bắt đầu',
        end_time: 'Ngày kết thúc',
        WTY_mileage: 'Số km bảo hành',
        List_of_claims: 'Lịch sử bảo hành',
        customer: 'Khách hàng',
        warranty_claim: 'Yêu cầu bảo hành',
        work_order: 'Lệnh sửa chữa',
        date_of_receipt: 'Ngày tiếp nhận',
        maintenance_technical_date: 'Ngày sửa chữa',
        mileage: 'Số km',
        state: 'Tình trạng',
        main_component: 'Phụ tùng chính',
        part_name: 'Tên phụ tùng _ Tiếng Anh',
        Recall_and_service_activities: 'Chiến dịch triệu hồi và dịch vụ',
        recall_and_service_activity_code: 'Mã chiến dịch triệu hồi và dịch vụ',
        recall_and_service_activity_names: 'Tên chiến dịch triệu hồi và dịch vụ',
        brand: 'Thương hiệu',
        recall_type_code: 'Mã loại triệu hồi',
        recall_type_name: 'Tên loại triệu hồi',
        release_date: 'Ngày phát hành',
        closing_date: 'Ngày đóng',
        complete: 'Đã hoàn thành',
        warranty_claim_status: 'Tình trạng yêu cầu bảo hành',
        end_of_maintenance_date: 'Ngày sửa chữa gần nhất',
        marketing_activity_code: 'Mã chiến dịch marketing',
        marketing_activity_name: 'Tên chiến dịch marketing',
        vehicle_warranty_period: 'Kỳ hạn bảo hành xe',
        marketing_activities: 'Hoạt động marketing',
        prohibition_of_claims: 'Cấm đòi lại',
        prohibited_claim_code: 'Mã cấm đòi lại',
        type_of_warranty_period: 'Loại kỳ hạn bảo hành',
        repair_end_date: 'Ngày kết thúc sửa chữa',
        reception_date: 'Ngày tiếp nhận',
        main_station_code: 'Mã trạm chính',
        main_workstation_name: 'Tên trạm làm việc chính',
        smvp_initiator: 'Người khởi xướng SMPV',
        contact_email: 'Email liên hệ SMPV',
        ssnw_doc_no: 'Số chứng từ SSNW',
        gws_doc_no: 'Số chứng từ GWS',
        missing_doc_reason: 'Lý do thiếu số chứng từ',
        part_return_no: 'Số phiếu trả phụ tùng',
        part_price: 'Giá phụ tùng($)',
        return_info: 'Thông tin trả lại',
        add_part: 'Thêm phụ tùng',
        initiate_part_return: 'Khởi tạo trả lại',
        domestic_return_form: 'Biểu mẫu trả trong nước',
        confirm_part_received: 'Xác nhận đã nhận',
        submit_analysis_report: 'Gửi báo cáo',
        fill_domestic_return_form: 'Điền biểu mẫu trong',
        view_overseas_return_info: 'Xem thông tin trả',
        confirm_domestic_part_return: 'Xác nhận trả trong nước',
        issue: 'Phát hành',
        fill_overseas_return_form: 'Điền biểu mẫu',
        confirm_overseas_part_return: 'Xác nhận trả ',
        view_overseas_return_form: 'Xem biểu mẫu',
        reject_reason: 'Lý do từ chối',
        choose_part: 'Chọn linh kiện',
        express_tracking_number: 'Số vận đơn chuyển phát nhanh',
        auditor: 'Người kiểm duyệt',
        recipient: 'Đối tượng',
        pickup_date: 'Ngày lấy hàng',
        consignee: 'Người nhận',
        consignee_company: 'Công ty người nhận',
        delivery_address: 'Địa chỉ giao hàng',
        consignee_phone: 'Điện thoại người nhận',
        shipper: 'Người gửi',
        shipper_company: 'Công ty người gửi',
        address: 'Địa chỉ',
        country_of_origin: 'Quốc gia xuất xứ',
        total_price: 'Tổng giá($)',
        analysis_rejection_reason: 'Lý do từ chối kết quả phân tích',
        export_invoice: 'Xuất hóa đơn',
        dhl_confirm_auth: 'Xác nhận ủy quyền DHL',
        reject_return_warning: 'Từ chối trả hàng có thể dẫn đến việc khấu trừ khoản bồi thường.',
        use_consignee_account_tip:
            'Sử dụng tài khoản người nhận để gửi hàng cần được ủy quyền. Vui lòng cung cấp email dùng để gửi hàng.',
    },
    // 西班牙
    esES: {
        vin: 'VIN',
        claim_information: 'Información de reclamación',
        marketing_activity_list: 'Lista de actividades de marketing',
        basic_information: 'Información básica',
        warranty_block: 'Bloque de garantía',
        repair_block_code: 'Código de bloque de garantía',
        claim_cycle_list: 'Lista de períodos de reclamación',
        WTY_Indicates_the_cycle_type: 'Tipo de período de garantía',
        start_time: 'Fecha de inicio',
        end_time: 'Fecha de finalización',
        WTY_mileage: 'Kilometraje de garantía',
        List_of_claims: 'Lista de formularios de reclamación',
        customer: 'Cliente',
        warranty_claim: 'Formulario de reclamación de garantía',
        work_order: 'Orden de trabajo',
        date_of_receipt: 'Fecha de recepción',
        maintenance_technical_date: 'Fecha de reparación técnica',
        mileage: 'Kilometraje',
        state: 'Estado',
        main_component: 'Componente principal',
        part_name: 'Nombre de la pieza',
        Recall_and_service_activities: 'Recall y actividades de servicio',
        recall_and_service_activity_code: 'Código de recall y actividades de servicio',
        recall_and_service_activity_names: 'Nombre de recall y actividades de servicio',
        brand: 'Marca',
        recall_type_code: 'Código de tipo de servicio',
        recall_type_name: 'Nombre de tipo de servicio',
        release_date: 'Fecha de publicación',
        closing_date: 'Fecha de cierre',
        complete: 'Completado',
        warranty_claim_status: 'Estado de reclamación de garantía',
        end_of_maintenance_date: 'Fecha de finalización de la reparación',
        marketing_activity_code: 'Código de actividad de mercado',
        marketing_activity_name: 'Nombre de actividad de mercado',
        vehicle_warranty_period: 'Período de garantía del vehículo',
        marketing_activities: 'Actividad de mercado',
        prohibition_of_claims: 'Prohibición de reclamación',
        prohibited_claim_code: 'Código de prohibición de reclamación',
        type_of_warranty_period: 'Tipo de período de garantía',
        repair_end_date: 'Fecha de finalización de la reparación',
        reception_date: 'Fecha de recepción',
        main_station_code: 'Código de estación de servicio principal',
        main_workstation_name: 'Nombre de estación de servicio principal',
        smvp_initiator: 'Iniciador del SMPV',
        contact_email: 'Correo electrónico de contacto SMPV',
        ssnw_doc_no: 'Número de documento SSNW',
        gws_doc_no: 'Número de documento GWS',
        missing_doc_reason: 'Razón del número de documento faltante',
        part_return_no: 'Número de devolución de pieza',
        part_price: 'Precio de la pieza($)',
        return_info: 'Información de devolución',
        add_part: 'Agregar pieza',
        initiate_part_return: 'Iniciar devolución',
        domestic_return_form: 'Formulario de devolución nacional',
        confirm_part_received: 'Confirmar recepción',
        submit_analysis_report: 'Enviar informe',
        fill_domestic_return_form: 'Rellenar formulario nacional',
        view_overseas_return_info: 'Ver información',
        confirm_domestic_part_return: 'Confirmar devolución nacional',
        issue: 'Asignar',
        fill_overseas_return_form: 'Rellenar formulario',
        confirm_overseas_part_return: 'Confirmar devolución',
        view_overseas_return_form: 'Ver formulario',
        reject_reason: 'Motivo de rechazo',
        choose_part: 'Seleccionar pieza',
        express_tracking_number: 'Número de seguimiento exprés',
        auditor: 'Auditor',
        recipient: 'Destinatario',
        pickup_date: 'Fecha de recogida',
        consignee: 'Destinatario',
        consignee_company: 'Empresa del destinatario',
        delivery_address: 'Dirección de entrega',
        consignee_phone: 'Teléfono del destinatario',
        shipper: 'Remitente',
        shipper_company: 'Empresa del remitente',
        address: 'Dirección',
        country_of_origin: 'País de origen',
        total_price: 'Precio total($)',
        analysis_rejection_reason: 'Motivo de rechazo del resultado del análisis',
        export_invoice: 'Exportar factura',
        dhl_confirm_auth: 'Confirmar autorización DHL',
        reject_return_warning:
            'Rechazar el retorno puede provocar una deducción en el monto de la reclamación.',
        use_consignee_account_tip:
            'Usar la cuenta del destinatario para el envío requiere su autorización. Proporcione el correo electrónico que se utilizará para el envío.',
    },
    // 葡萄牙
    ptBR: {
        vin: 'VIN',
        claim_information: 'Informação de reivindicação',
        marketing_activity_list: 'Lista de atividades de marketing',
        basic_information: 'Informação básica',
        warranty_block: 'Bloqueio da garantia',
        repair_block_code: 'Código do bloco de reparo',
        claim_cycle_list: 'Lista de ciclos de reivindicação',
        WTY_Indicates_the_cycle_type: 'WTY Indica o tipo de ciclo',
        start_time: 'Hora de início',
        end_time: 'Hora de término',
        WTY_mileage: 'WTY Quilometragem',
        List_of_claims: 'Lista de reivindicações',
        customer: 'Cliente',
        warranty_claim: 'Reivindicação de garantia',
        work_order: 'Ordem de trabalho',
        date_of_receipt: 'Data de recebimento',
        maintenance_technical_date: 'Data técnica de manutenção',
        mileage: 'Quilometragem',
        state: 'Estado',
        main_component: 'Componente principal',
        part_name: 'Nome da peça',
        Recall_and_service_activities: 'Atividades de recall e serviço',
        recall_and_service_activity_code: 'Código da atividade de recall e serviço',
        recall_and_service_activity_names: 'Nomes das atividades de recall e serviço',
        brand: 'Marca',
        recall_type_code: 'Código do tipo de recall',
        recall_type_name: 'Nome do tipo de recall',
        release_date: 'Data de lançamento',
        closing_date: 'Data de encerramento',
        complete: 'Completo',
        warranty_claim_status: 'Status da reivindicação de garantia',
        end_of_maintenance_date: 'Data de término da manutenção',
        marketing_activity_code: 'Código da atividade de marketing',
        marketing_activity_name: 'Nome da atividade de marketing',
        vehicle_warranty_period: 'Período de garantia do veículo',
        marketing_activities: 'Atividades de marketing',
        prohibition_of_claims: 'Proibição de reivindicações',
        prohibited_claim_code: 'Código de reivindicação proibida',
        type_of_warranty_period: 'Tipo de período de garantia',
        repair_end_date: 'Data de término do reparo',
        reception_date: 'Data de recepção',
        main_station_code: 'Código da estação principal',
        main_workstation_name: 'Nome da estação de trabalho principal',
        smvp_initiator: 'Iniciador do SMPV',
        contact_email: 'E-mail de contato do SMPV',
        ssnw_doc_no: 'Número do documento SSNW',
        gws_doc_no: 'Número do documento GWS',
        missing_doc_reason: 'Motivo do número do documento ausente',
        part_return_no: 'Número de devolução da peça',
        part_price: 'Preço da peça($)',
        return_info: 'Informações de devolução',
        add_part: 'Adicionar peça',
        initiate_part_return: 'Iniciar devolução',
        domestic_return_form: 'Formulário de devolução nacional',
        confirm_part_received: 'Confirmar recebimento',
        submit_analysis_report: 'Enviar relatório',
        fill_domestic_return_form: 'Preencher formulário nacional',
        view_overseas_return_info: 'Ver informações',
        confirm_domestic_part_return: 'Confirmar devolução nacional',
        issue: 'Emitir',
        fill_overseas_return_form: 'Preencher formulário',
        confirm_overseas_part_return: 'Confirmar devolução',
        view_overseas_return_form: 'Ver formulário',
        reject_reason: 'Motivo da recusa',
        choose_part: 'Selecionar peça',
        express_tracking_number: 'Número de rastreamento expresso',
        auditor: 'Auditor',
        recipient: 'Destinatário',
        pickup_date: 'Data de coleta',
        consignee: 'Destinatário',
        consignee_company: 'Empresa do destinatário',
        delivery_address: 'Endereço de entrega',
        consignee_phone: 'Telefone do destinatário',
        shipper: 'Remetente',
        shipper_company: 'Empresa do remetente',
        address: 'Endereço',
        country_of_origin: 'País de origem',
        total_price: 'Preço total($)',
        analysis_rejection_reason: 'Motivo de rejeição do resultado da análise',
        export_invoice: 'Exportar fatura',
        dhl_confirm_auth: 'Confirmar autorização DHL',
        reject_return_warning:
            'Recusar a devolução pode resultar em desconto no valor do reembolso solicitado.',
        use_consignee_account_tip:
            'O uso da conta do destinatário para envio requer autorização. Forneça o e-mail a ser usado para o envio.',
    },
    // 波兰
    plPL: {
        vin: 'VIN',
        claim_information: 'Informacje o reklamacji',
        marketing_activity_list: 'Kampania marketingowa',
        basic_information: 'Informacje podstawowe',
        warranty_block: 'Blok gwarancyjny',
        repair_block_code: 'Kod bloku gwarancyjnego',
        claim_cycle_list: 'Lista okresowa reklamacji',
        WTY_Indicates_the_cycle_type: 'Typ okresu reklamacji',
        start_time: 'Data rozpoczęcia',
        end_time: 'Data zakończenia',
        WTY_mileage: 'Przebieg',
        List_of_claims: 'Historia reklamacji',
        customer: 'Klient',
        warranty_claim: 'Roszczenie gwarancyjne',
        work_order: 'Zlecenie prac',
        date_of_receipt: 'Data przyjęcia',
        maintenance_technical_date: 'Data naprawy',
        mileage: 'Przebieg',
        state: 'Status',
        main_component: 'Główna część',
        part_name: 'Nazwa części_pl',
        Recall_and_service_activities: 'Akcja',
        recall_and_service_activity_code: 'Kod akcji recall&service',
        recall_and_service_activity_names: 'Nazwa akcji recall&service',
        brand: 'Marka',
        recall_type_code: 'Kod typu akcji',
        recall_type_name: 'Nazwa typu akcji',
        release_date: 'Data ogłoszenia',
        closing_date: 'Data zamknięcia',
        complete: 'Zakończone',
        warranty_claim_status: 'Status roszczenia gwarancyjnego',
        end_of_maintenance_date: 'Data zakończenia ostatniej naprawy',
        marketing_activity_code: 'Kod kampanii marketingowej',
        marketing_activity_name: 'Nazwa kampanii marketingowej',
        vehicle_warranty_period: 'Okres gwarancji pojazdu',
        marketing_activities: 'Działalność marktingowa',
        prohibition_of_claims: 'Zakaz roszczeń',
        prohibited_claim_code: 'Kod zakazanego roszczenia',
        type_of_warranty_period: 'Typ okresu gwarancji',
        repair_end_date: 'Data zakończenia naprawy',
        reception_date: 'Data przyjęcia',
        main_station_code: 'Kod głównej stacji obługi',
        main_workstation_name: 'Nazwa glównej stacji obsługi',
        smvp_initiator: 'Inicjator SMPV',
        contact_email: 'Adres e-mail kontaktowy SMPV',
        ssnw_doc_no: 'Numer dokumentu SSNW',
        gws_doc_no: 'Numer dokumentu GWS',
        missing_doc_reason: 'Powód braku numeru dokumentu',
        part_return_no: 'Numer zwrotu części',
        part_price: 'Cena części($)',
        return_info: 'Informacje o zwrocie',
        add_part: 'Dodaj część',
        initiate_part_return: 'Zainicjuj zwrot',
        domestic_return_form: 'Formularz zwrotu krajowego',
        confirm_part_received: 'Potwierdź odbiór',
        submit_analysis_report: 'Wyślij raport',
        fill_domestic_return_form: 'Wypełnij formularz krajowy',
        view_overseas_return_info: 'Zobacz info o zwrocie',
        confirm_domestic_part_return: 'Potwierdź zwrot krajowy',
        issue: 'Wystaw',
        fill_overseas_return_form: 'Wypełnij formularz',
        confirm_overseas_part_return: 'Potwierdź zwrot',
        view_overseas_return_form: 'Zobacz formularz',
        reject_reason: 'Powód odrzucenia',
        choose_part: 'Wybierz część',
        express_tracking_number: 'Numer przesyłki ekspresowej',
        auditor: 'Auditor',
        recipient: 'Odbiorca',
        pickup_date: 'Data odbioru',
        consignee: 'Odbiorca',
        consignee_company: 'Firma odbiorcy',
        delivery_address: 'Adres dostawy',
        consignee_phone: 'Telefon odbiorcy',
        shipper: 'Nadawca',
        shipper_company: 'Firma nadawcy',
        address: 'Adres',
        country_of_origin: 'Kraj pochodzenia',
        total_price: 'Cena całkowita($)',
        analysis_rejection_reason: 'Powód odrzucenia wyniku analizy',
        export_invoice: 'Eksportuj fakturę',
        dhl_confirm_auth: 'Potwierdź upoważnienie DHL',
        reject_return_warning: 'Odrzucenie zwrotu może skutkować odliczeniem od kwoty roszczenia.',
        use_consignee_account_tip:
            'Wysyłka za pomocą konta odbiorcy wymaga jego autoryzacji. Podaj adres e-mail, który ma zostać użyty do wysyłki.',
    },
    // 土耳其
    trTR: {
        vin: 'VIN',
        claim_information: 'Kleym bilgileriİstem bilgileri',
        marketing_activity_list: 'Pazarlama kampanyası',
        basic_information: 'Temel bilgi',
        warranty_block: 'Garanti Grubu',
        repair_block_code: 'Garanti Blok Kodu',
        claim_cycle_list: 'WTY dönem listesi',
        WTY_Indicates_the_cycle_type: 'WTY dönem türü',
        start_time: 'Başlangıç tarihi',
        end_time: 'Bitiş Tarihi',
        WTY_mileage: 'Km si',
        List_of_claims: 'WTY geçmişi',
        customer: 'Müşterisi',
        warranty_claim: 'Garanti  kleymi',
        work_order: 'İş emri',
        date_of_receipt: 'Kabul Tarihi',
        maintenance_technical_date: 'Onarım tarihi',
        mileage: 'Km si',
        state: 'Durum',
        main_component: 'Ana parça',
        part_name: 'Parça adı',
        Recall_and_service_activities: 'Geri çağırma kampanyası',
        recall_and_service_activity_code: 'Geri çağırma kampanya adı',
        recall_and_service_activity_names: 'Geri çağırma kampanya kodu',
        brand: 'Marka',
        recall_type_code: 'Geri çağırma tipi kodu',
        recall_type_name: 'Geri çağırma tipi adı',
        release_date: 'Yayınlanma tarihi',
        closing_date: 'Kapanma tarihi',
        complete: 'Tamamlandı',
        warranty_claim_status: 'Garanti kleym durumu',
        end_of_maintenance_date: 'Son onarma tarihi',
        marketing_activity_code: 'Pazarlama kampanya kodu',
        marketing_activity_name: 'Pazarlama kampanya adı',
        vehicle_warranty_period: 'Araç garanti dönemi',
        marketing_activities: 'Pazarlama etkinlikleri',
        prohibition_of_claims: 'Kleym yapılamaz',
        prohibited_claim_code: 'Yapılamaz kley kodu',
        type_of_warranty_period: 'Garanti peryotye türü',
        repair_end_date: 'Onarım bitiş tarihi',
        reception_date: 'Kabul tarihi',
        main_station_code: 'Ana istasyon kodu',
        main_workstation_name: 'Ana çalışma istasyonu ismi',
        smvp_initiator: 'SMPV Girişimcisi',
        contact_email: 'SMPV İletişim E-postası',
        ssnw_doc_no: 'SSNW Belge Numarası',
        gws_doc_no: 'GWS Belge Numarası',
        missing_doc_reason: 'Belge numarası eksik olma nedeni',
        part_return_no: 'Parça iade numarası',
        part_price: 'Parça fiyatı($)',
        return_info: 'İade bilgileri',
        add_part: 'Parça ekle',
        initiate_part_return: 'İade başlat',
        domestic_return_form: 'Yurt içi iade formu',
        confirm_part_received: 'Teslimatı onayla',
        submit_analysis_report: 'Raporu gönder',
        fill_domestic_return_form: 'Yurt içi formu doldur',
        view_overseas_return_info: 'iade bilgilerini görüntüle',
        confirm_domestic_part_return: 'Yurt içi iadeyi onayla',
        issue: 'Gönder',
        fill_overseas_return_form: 'Formu doldur',
        confirm_overseas_part_return: 'Iadeyi onayla',
        view_overseas_return_form: 'Formunu görüntüle',
        reject_reason: 'Reddetme nedeni',
        choose_part: 'Parça seçin',
        express_tracking_number: 'Express Kargo Takip Numarası',
        auditor: 'Denetleyici',
        recipient: 'Alıcı',
        pickup_date: 'Teslim alma tarihi',
        consignee: 'Alıcı',
        consignee_company: 'Alıcı şirketi',
        delivery_address: 'Teslimat adresi',
        consignee_phone: 'Alıcı telefonu',
        shipper: 'Gönderici',
        shipper_company: 'Gönderici şirket',
        address: 'Adres',
        country_of_origin: 'Menşei ülke',
        total_price: 'Toplam fiyat($)',
        analysis_rejection_reason: 'Analiz sonucunun reddedilme nedeni',
        export_invoice: 'Faturayı dışa aktar',
        dhl_confirm_auth: 'DHL Yetkisini Onayla',
        reject_return_warning: 'İadeyi reddetmek, tazminat tutarından kesintiye neden olabilir.',
        use_consignee_account_tip:
            'Alıcının hesabı kullanılarak gönderim yapmak için yetkilendirme gerekir. Lütfen gönderim için kullanılacak e-postayı sağlayın.',
    },
    // 捷克语
    csCZ: {
        vin: 'VIN',
        claim_information: 'Informace o reklamaci',
        marketing_activity_list: 'Marketingová kampaň',
        basic_information: 'Základní informace',
        warranty_block: 'Warranty block',
        repair_block_code: 'Kód záručního bloku',
        claim_cycle_list: 'Seznam období záruky',
        WTY_Indicates_the_cycle_type: 'Typ období záruky',
        start_time: 'Datum zahájení',
        end_time: 'Datum ukončení',
        WTY_mileage: 'WTY mileage',
        List_of_claims: 'historie záruky',
        customer: 'Zákazník',
        warranty_claim: 'Záruční reklamace',
        work_order: 'Zakázka',
        date_of_receipt: 'Datum přijetí',
        maintenance_technical_date: 'Termín opravy',
        mileage: 'Počet najetých kilometrů',
        state: 'Status',
        main_component: 'Hlavní část',
        part_name: 'Název dílu_en',
        Recall_and_service_activities: 'Svolávací a servisní kampaň',
        recall_and_service_activity_code: 'Kód kampaně a svolávací akce',
        recall_and_service_activity_names: 'Jméno kampaně a svolávací akce',
        brand: 'Značka',
        recall_type_code: 'Typ kódu svolávací kampaně',
        recall_type_name: 'Název svolávací kampaně',
        release_date: 'Datum vydání',
        closing_date: 'Datum uzavření',
        complete: 'Dokončeno',
        warranty_claim_status: 'Stav reklamace',
        end_of_maintenance_date: 'Datum ukončení poslední opravy',
        marketing_activity_code: 'Kód marketingové kampaně',
        marketing_activity_name: 'Název marketingové kampaně',
        vehicle_warranty_period: 'Záruční doba vozidla',
        marketing_activities: 'Marketingové aktivity',
        prohibition_of_claims: 'Zákaz reklamací',
        prohibited_claim_code: 'Kód zakázaných reklamací',
        type_of_warranty_period: 'Typ záruční doby',
        repair_end_date: 'Datum ukončení opravy',
        reception_date: 'Datum příjmu',
        main_station_code: 'Main station code',
        main_workstation_name: 'Main workstation name',
        smvp_initiator: 'Iniciátor SMPV',
        contact_email: 'Kontaktní e-mail SMPV',
        ssnw_doc_no: 'Číslo dokumentu SSNW',
        gws_doc_no: 'Číslo dokumentu GWS',
        missing_doc_reason: 'Důvod chybějícího čísla dokumentu',
        part_return_no: 'Číslo vrácení dílu',
        part_price: 'Cena dílu($)',
        return_info: 'Informace o návratu',
        add_part: 'Přidat díl',
        initiate_part_return: 'Spustit návrat',
        domestic_return_form: 'Formulář domácího návratu',
        confirm_part_received: 'Potvrdit přijetí',
        submit_analysis_report: 'Odeslat zprávu',
        fill_domestic_return_form: 'Vyplnit domácí formulář',
        view_overseas_return_info: 'Zobrazit informace o návratu',
        confirm_domestic_part_return: 'Potvrdit domácí návrat',
        issue: 'Vydání',
        fill_overseas_return_form: 'Vyplnit formulář',
        confirm_overseas_part_return: 'Potvrdit návrat',
        view_overseas_return_form: 'Zobrazit formulář',
        reject_reason: 'Důvod zamítnutí',
        choose_part: 'Vybrat díl',
        express_tracking_number: 'Číslo sledování expresní zásilky',
        auditor: 'Kontrolor',
        recipient: 'Příjemce',
        pickup_date: 'Datum vyzvednutí',
        consignee: 'Příjemce',
        consignee_company: 'Společnost příjemce',
        delivery_address: 'Dodací adresa',
        consignee_phone: 'Telefon příjemce',
        shipper: 'Odesílatel',
        shipper_company: 'Společnost odesílatele',
        address: 'Adresa',
        country_of_origin: 'Země původu',
        total_price: 'Celková cena($)',
        analysis_rejection_reason: 'Důvod zamítnutí analytického výsledku',
        export_invoice: 'Exportovat fakturu',
        dhl_confirm_auth: 'Potvrdit autorizaci DHL',
        reject_return_warning: 'Odmítnutí vrácení zásilky může vést ke srážce z částky nároku.',
        use_consignee_account_tip:
            'Použití účtu příjemce pro zásilku vyžaduje jeho autorizaci. Zadejte e-mail, který se má použít pro odeslání.',
    },
    // 匈牙利语
    huHU: {
        vin: 'Alvázszám',
        claim_information: 'Igényinformáció',
        marketing_activity_list: 'Marketingkampány',
        basic_information: 'Alapvető információ',
        warranty_block: 'Garanciablokk',
        repair_block_code: 'Garanciablokk kódja',
        claim_cycle_list: 'Gar. időszak lista',
        WTY_Indicates_the_cycle_type: 'Gar. időszak típusa',
        start_time: 'Kezdő dátum',
        end_time: 'Befejező dátum',
        WTY_mileage: 'Gar. futásteljesítmény',
        List_of_claims: 'Gar. előzmények',
        customer: 'Ügyfél',
        warranty_claim: 'Garanciális igény',
        work_order: 'Munkautasítás',
        date_of_receipt: 'Átvétel dátuma',
        maintenance_technical_date: 'Javítás dátuma',
        mileage: 'Futásteljesítmény',
        state: 'Állapot',
        main_component: 'Fődarab',
        part_name: 'Alkatrésznév',
        Recall_and_service_activities: 'Visszahívási és szervizkampány',
        recall_and_service_activity_code: 'Visszahívási és szervizkampány kódja',
        recall_and_service_activity_names: 'Visszahívási és szervizkampány neve',
        brand: 'Márka',
        recall_type_code: 'Visszahívási típus kódja',
        recall_type_name: 'Visszahívási típus neve',
        release_date: 'Kiadási dátum',
        closing_date: 'Lezárás dátuma',
        complete: 'Kész',
        warranty_claim_status: 'Garanciális igény állapota',
        end_of_maintenance_date: 'Legutóbbi javítás befejező dátuma',
        marketing_activity_code: 'Marketingkampány kódja',
        marketing_activity_name: 'Marketingkampány neve',
        vehicle_warranty_period: 'Jármű garanciális időszaka',
        marketing_activities: 'Marketingtevékenységek',
        prohibition_of_claims: 'Igények megtiltása',
        prohibited_claim_code: 'Tiltott igény kódja',
        type_of_warranty_period: 'Garanciális időszak típusa',
        repair_end_date: 'Javítás befejező dátuma',
        reception_date: 'Átvétel dátuma',
        main_station_code: 'Fő állomás kódja',
        main_workstation_name: 'Fő műhely kódja',
        smvp_initiator: 'SMPV kezdeményező',
        contact_email: 'SMPV kapcsolati e-mail',
        ssnw_doc_no: 'SSNW dokumentumszám',
        gws_doc_no: 'GWS dokumentumszám',
        missing_doc_reason: 'A dokumentumszám hiányzásának oka',
        part_return_no: 'Alkatrész visszaszállítási szám',
        part_price: 'Alkatrész ár($)',
        return_info: 'Visszaküldési információk',
        add_part: 'Alkatrész hozzáadása',
        initiate_part_return: 'Visszaküldés indítása',
        domestic_return_form: 'Hazai visszaküldési űrlap',
        confirm_part_received: 'Fogadás megerősítése',
        submit_analysis_report: 'Jelentés beküldése',
        fill_domestic_return_form: 'Hazai űrlap kitöltése',
        view_overseas_return_info: 'visszaküldési információk',
        confirm_domestic_part_return: 'Hazai visszaküldés megerősítése',
        issue: 'Kibocsátás',
        fill_overseas_return_form: 'űrlap kitöltése',
        confirm_overseas_part_return: 'visszaküldés megerősítése',
        view_overseas_return_form: 'űrlap megtekintése',
        reject_reason: 'Elutasítás oka',
        choose_part: 'Alkatrész kiválasztása',
        express_tracking_number: 'Gyors szállítmány nyomon követési száma',
        auditor: 'Auditáló',
        recipient: 'Címzett',
        pickup_date: 'Átvétel dátuma',
        consignee: 'Címzett',
        consignee_company: 'Címzett cég',
        delivery_address: 'Szállítási cím',
        consignee_phone: 'Címzett telefonszáma',
        shipper: 'Feladó',
        shipper_company: 'Feladó cég',
        address: 'Cím',
        country_of_origin: 'Eredet országa',
        total_price: 'Teljes ár($)',
        analysis_rejection_reason: 'Az elemzési eredmény elutasításának oka',
        export_invoice: 'Számla exportálása',
        dhl_confirm_auth: 'DHL felhatalmazás megerősítése',
        reject_return_warning:
            'A visszaküldés elutasítása kártérítési összeg levonásához vezethet.',
        use_consignee_account_tip:
            'A címzett fiókjának használata küldésre engedélyt igényel. Kérjük, adja meg a küldéshez használandó e-mail címet.',
    },
    // 俄罗斯语
    ruRU: {
        vin: 'Идентификационный номер автомобиля',
        claim_information: 'Информация о претензии',
        marketing_activity_list: 'Список маркетинговых мероприятий',
        basic_information: 'Основная информация',
        warranty_block: 'Гарантийный блок',
        repair_block_code: 'Код гарантийного блока',
        claim_cycle_list: 'Список циклов претензий',
        WTY_Indicates_the_cycle_type: 'Тип цикла гарантии',
        start_time: 'Время начала',
        end_time: 'Время окончания',
        WTY_mileage: 'Пробег гарантии',
        List_of_claims: 'Список претензий',
        customer: 'Клиент',
        warranty_claim: 'Гарантийная претензия',
        work_order: 'Рабочий заказ',
        date_of_receipt: 'Дата получения',
        maintenance_technical_date: 'Дата ремонта',
        mileage: 'Пробег',
        state: 'Статус',
        main_component: 'Основная деталь',
        part_name: 'Название детали',
        Recall_and_service_activities: 'Программа отзывов и сервисные мероприятия',
        recall_and_service_activity_code: 'Код программы отзыва и сервисной активности',
        recall_and_service_activity_names: 'Название программы отзыва и сервисной активности',
        brand: 'Бренд',
        recall_type_code: 'Код типа отзыва',
        recall_type_name: 'Название типа отзыва',
        release_date: 'Дата выпуска',
        closing_date: 'Дата закрытия',
        complete: 'Завершено',
        warranty_claim_status: 'Статус гарантийной претензии',
        end_of_maintenance_date: 'Дата завершения последнего ремонта',
        marketing_activity_code: 'Код маркетинговой кампании',
        marketing_activity_name: 'Название маркетинговой кампании',
        vehicle_warranty_period: 'Период гарантии на транспортное средство',
        marketing_activities: 'Маркетинговые мероприятия',
        prohibition_of_claims: 'Запрет на претензии',
        prohibited_claim_code: 'Код запрещенных претензий',
        type_of_warranty_period: 'Тип гарантии',
        repair_end_date: 'Дата завершения ремонта',
        reception_date: 'Дата приема',
        main_station_code: 'Код основного рабочего места',
        main_workstation_name: 'Название основного рабочего места',
        smvp_initiator: 'Инициатор SMPV',
        contact_email: 'Электронная почта контактного лица SMPV',
        ssnw_doc_no: 'Номер документа SSNW',
        gws_doc_no: 'Номер документа GWS',
        missing_doc_reason: 'Причина отсутствия номера документа',
        part_return_no: 'Номер возврата детали',
        part_price: 'Цена детали($)',
        return_info: 'Информация о возврате',
        add_part: 'Добавить деталь',
        initiate_part_return: 'Инициировать возврат',
        domestic_return_form: 'Форма внутреннего возврата',
        confirm_part_received: 'Подтвердить получение',
        submit_analysis_report: 'Отправить отчет',
        fill_domestic_return_form: 'Заполнить внутреннюю форму',
        view_overseas_return_info: 'Просмотр информации о возврате',
        confirm_domestic_part_return: 'Подтвердить внутренний возврат',
        issue: 'Выдать',
        fill_overseas_return_form: 'Заполнить форму',
        confirm_overseas_part_return: 'Подтвердить возврат',
        view_overseas_return_form: 'Просмотр формы',
        reject_reason: 'Причина отказа',
        choose_part: 'Выбрать деталь',
        express_tracking_number: 'Номер отслеживания экспресс-доставки',
        auditor: 'Аудитор',
        recipient: 'Получатель',
        pickup_date: 'Дата забора',
        consignee: 'Получатель',
        consignee_company: 'Компания получателя',
        delivery_address: 'Адрес доставки',
        consignee_phone: 'Телефон получателя',
        shipper: 'Отправитель',
        shipper_company: 'Компания отправителя',
        address: 'Адрес',
        country_of_origin: 'Страна происхождения',
        total_price: 'Общая цена($)',
        analysis_rejection_reason: 'Причина отказа в результате анализа',
        export_invoice: 'Экспорт счета',
        dhl_confirm_auth: 'Подтвердить авторизацию DHL',
        reject_return_warning:
            'Отказ от возврата может привести к удержанию части страхового возмещения.',
        use_consignee_account_tip:
            'Для отправки через аккаунт получателя требуется его авторизация. Укажите адрес электронной почты, который будет использоваться для отправки.',
    },
    // 沙特阿拉伯
    arSA: {
        vin: 'VIN',
        claim_information: 'معلومات المطالبة',
        marketing_activity_list: 'قائمة الأنشطة التسويقية',
        basic_information: 'المعلومات الأساسية',
        warranty_block: 'كتلة الضمان',
        repair_block_code: 'رمز كتلة الإصلاح',
        claim_cycle_list: 'قائمة دورة المطالبة',
        WTY_Indicates_the_cycle_type: 'نوع دورة الضمان (WTY)',
        start_time: 'وقت البدء',
        end_time: 'وقت الانتهاء',
        WTY_mileage: 'المسافة المقطوعة لضمان WTY',
        List_of_claims: 'قائمة طلبات المطالبة',
        customer: 'العميل',
        warranty_claim: 'طلب ضمان',
        work_order: 'أمر العمل',
        date_of_receipt: 'تاريخ الاستلام',
        maintenance_technical_date: 'تاريخ الصيانة الفنية',
        mileage: 'المسافة المقطوعة',
        state: 'الحالة',
        main_component: 'المكوّن الرئيسي',
        part_name: 'اسم القطعة',
        Recall_and_service_activities: 'أنشطة الاستدعاء والخدمة',
        recall_and_service_activity_code: 'رمز نشاط الاستدعاء والخدمة',
        recall_and_service_activity_names: 'أسماء أنشطة الاستدعاء والخدمة',
        brand: 'العلامة التجارية',
        recall_type_code: 'رمز نوع الخدمة',
        recall_type_name: 'اسم نوع الخدمة',
        release_date: 'تاريخ الإصدار',
        closing_date: 'تاريخ الإغلاق',
        complete: 'مكتمل',
        warranty_claim_status: 'حالة طلب الضمان',
        end_of_maintenance_date: 'تاريخ انتهاء الصيانة',
        marketing_activity_code: 'رمز النشاط التسويقي',
        marketing_activity_name: 'اسم النشاط التسويقي',
        vehicle_warranty_period: 'فترة ضمان المركبة',
        marketing_activities: 'الأنشطة التسويقية',
        prohibition_of_claims: 'حظر المطالبات',
        prohibited_claim_code: 'رمز المطالبة المحظورة',
        type_of_warranty_period: 'نوع فترة الضمان',
        repair_end_date: 'تاريخ انتهاء الإصلاح',
        reception_date: 'تاريخ الاستقبال',
        main_station_code: 'رمز المحطة الرئيسية',
        main_workstation_name: 'اسم المحطة الرئيسية',
        smvp_initiator: 'مبادر SMPV',
        contact_email: 'البريد الإلكتروني للتواصل مع SMPV',
        ssnw_doc_no: 'رقم مستند SSNW',
        gws_doc_no: 'رقم مستند GWS',
        missing_doc_reason: 'سبب فقدان رقم المستند',
        part_return_no: 'رقم إرجاع القطعة',
        part_price: 'سعر القطعة ($)',
        return_info: 'معلومات الإرجاع',
        add_part: 'إضافة قطعة',
        initiate_part_return: 'بدء إرجاع القطعة',
        domestic_return_form: 'نموذج إرجاع محلي',
        confirm_part_received: 'تأكيد استلام القطعة',
        submit_analysis_report: 'تقديم تقرير التحليل',
        fill_domestic_return_form: 'تعبئة نموذج الإرجاع المحلي',
        view_overseas_return_info: 'عرض معلومات الإرجاع الدولي',
        confirm_domestic_part_return: 'تأكيد إرجاع القطعة محليًا',
        issue: 'إصدار',
        fill_overseas_return_form: 'تعبئة نموذج الإرجاع الدولي',
        confirm_overseas_part_return: 'تأكيد إرجاع القطعة دوليًا',
        view_overseas_return_form: 'عرض نموذج الإرجاع الدولي',
        reject_reason: 'سبب الرفض',
        choose_part: 'اختيار قطعة',
        express_tracking_number: 'رقم تتبع الشحن السريع',
        auditor: 'المراجع',
        recipient: 'جهة الاستلام',
        pickup_date: 'تاريخ استلام الشحنة من قبل شركة الشحن',
        consignee: 'المستلم',
        consignee_company: 'شركة المستلم',
        delivery_address: 'عنوان التسليم',
        consignee_phone: 'هاتف المستلم',
        shipper: 'المرسِل',
        shipper_company: 'شركة المرسِل',
        address: 'العنوان',
        country_of_origin: 'بلد المنشأ',
        total_price: 'السعر الإجمالي ($)',
        analysis_rejection_reason: 'سبب رفض نتيجة التحليل',
        export_invoice: 'تصدير الفاتورة',
        dhl_confirm_auth: 'تأكيد تفويض DHL',
        reject_return_warning: 'قد يؤدي رفض الإرجاع إلى خصم مبلغ المطالبة',
        use_consignee_account_tip:
            'يتطلب استخدام حساب المستلم للشحن تفويضًا منهم؛ يُرجى تقديم البريد الإلكتروني المستخدم للشحن',
    },
    // 保加利亚
    bgBG: {
        vin: 'VIN',
        claim_information: 'Информация за искане',
        marketing_activity_list: 'Списък с маркетингови активности',
        basic_information: 'Основна информация',
        warranty_block: 'Блок за гаранция',
        repair_block_code: 'Код на ремонтен блок',
        claim_cycle_list: 'Списък с цикли на искания',
        WTY_Indicates_the_cycle_type: 'Тип на WTY цикъл',
        start_time: 'Начално време',
        end_time: 'Крайно време',
        WTY_mileage: 'Пробег по WTY',
        List_of_claims: 'Списък с искания',
        customer: 'Клиент',
        warranty_claim: 'Гаранционно искане',
        work_order: 'Наредба за работа',
        date_of_receipt: 'Дата на получаване',
        maintenance_technical_date: 'Техническа дата на поддръжка',
        mileage: 'Пробег',
        state: 'Състояние',
        main_component: 'Основен компонент',
        part_name: 'Име на частта',
        Recall_and_service_activities: 'Акции за отзив и обслужване',
        recall_and_service_activity_code: 'Код на акция за отзив и обслужване',
        recall_and_service_activity_names: 'Имена на акции за отзив и обслужване',
        brand: 'Марка',
        recall_type_code: 'Код на тип услуга',
        recall_type_name: 'Име на тип услуга',
        release_date: 'Дата на публикуване',
        closing_date: 'Дата на приключване',
        complete: 'Завършено',
        warranty_claim_status: 'Статус на гаранционното искане',
        end_of_maintenance_date: 'Дата на приключване на поддръжката',
        marketing_activity_code: 'Код на маркетингова активност',
        marketing_activity_name: 'Име на маркетингова активност',
        vehicle_warranty_period: 'Период на гаранция на превозното средство',
        marketing_activities: 'Маркетингови активности',
        prohibition_of_claims: 'Забрана за искания',
        prohibited_claim_code: 'Код на забранено искане',
        type_of_warranty_period: 'Тип на гаранционен период',
        repair_end_date: 'Дата на приключване на ремонта',
        reception_date: 'Дата на приемане',
        main_station_code: 'Код на основната работна станция',
        main_workstation_name: 'Име на основната работна станция',
        smvp_initiator: 'Инициатор на SMVP',
        contact_email: 'Имейл за контакт на SMVP',
        ssnw_doc_no: 'Номер на SSNW документ',
        gws_doc_no: 'Номер на GWS документ',
        missing_doc_reason: 'Причина за липсващ номер на документ',
        part_return_no: 'Номер на връщане на част',
        part_price: 'Цена на частта ($)',
        return_info: 'Информация за връщане',
        add_part: 'Добавяне на част',
        initiate_part_return: 'Иницииране на връщане на част',
        domestic_return_form: 'Формуляр за вътрешно връщане',
        confirm_part_received: 'Потвърждаване на получаване на частта',
        submit_analysis_report: 'Подаване на аналитичен доклад',
        fill_domestic_return_form: 'Попълване на формуляр за вътрешно връщане',
        view_overseas_return_info: 'Преглед на информация за международно връщане',
        confirm_domestic_part_return: 'Потвърждаване на вътрешно връщане на част',
        issue: 'Изпращане',
        fill_overseas_return_form: 'Попълване на формуляр за международно връщане',
        confirm_overseas_part_return: 'Потвърждаване на международно връщане на част',
        view_overseas_return_form: 'Преглед на формуляр за международно връщане',
        reject_reason: 'Причина за отказ',
        choose_part: 'Избор на част',
        express_tracking_number: 'Номер за проследяване на експресна пратка',
        auditor: 'Одитор',
        recipient: 'Получател',
        pickup_date: 'Дата на вземане от куриер',
        consignee: 'Получател на пратката',
        consignee_company: 'Компания на получателя',
        delivery_address: 'Адрес за доставка',
        consignee_phone: 'Телефон на получателя',
        shipper: 'Подател',
        shipper_company: 'Компания на подателя',
        address: 'Адрес',
        country_of_origin: 'Държава на произход',
        total_price: 'Обща цена ($)',
        analysis_rejection_reason: 'Причина за отказ на анализа',
        export_invoice: 'Експортиране на фактура',
        dhl_confirm_auth: 'Потвърждение на упълномощяване от DHL',
        reject_return_warning:
            'Отказът от връщане може да доведе до намаление на сумата по искането',
        use_consignee_account_tip:
            'Използването на акаунт на получателя за изпращане изисква тяхно разрешение; моля, предоставете имейла, използван за изпращане',
    },
    // 丹麦语
    daDK: {
        vin: 'VIN',
        claim_information: 'Kravoplysninger',
        marketing_activity_list: 'Liste over markedsføringsaktiviteter',
        basic_information: 'Grundlæggende oplysninger',
        warranty_block: 'Garantiblok',
        repair_block_code: 'Reparationsblokkode',
        claim_cycle_list: 'Liste over kravcyklusser',
        WTY_Indicates_the_cycle_type: 'WTY-cyklustype',
        start_time: 'Starttidspunkt',
        end_time: 'Sluttidspunkt',
        WTY_mileage: 'WTY-kilometertal',
        List_of_claims: 'Liste over krav',
        customer: 'Kunde',
        warranty_claim: 'Garantikrav',
        work_order: 'Arbejdsordre',
        date_of_receipt: 'Modtagelsesdato',
        maintenance_technical_date: 'Teknisk vedligeholdelsesdato',
        mileage: 'Kilometertal',
        state: 'Status',
        main_component: 'Hovedkomponent',
        part_name: 'Reservedelsnavn',
        Recall_and_service_activities: 'Tilbagetrækning og serviceaktiviteter',
        recall_and_service_activity_code: 'Kode for tilbagetrækning og serviceaktivitet',
        recall_and_service_activity_names: 'Navne på tilbagetræknings- og serviceaktiviteter',
        brand: 'Mærke',
        recall_type_code: 'Servicetypekode',
        recall_type_name: 'Servicetypenavn',
        release_date: 'Udgivelsesdato',
        closing_date: 'Lukkedato',
        complete: 'Fuldført',
        warranty_claim_status: 'Status for garantikrav',
        end_of_maintenance_date: 'Slutdato for vedligeholdelse',
        marketing_activity_code: 'Markedsføringsaktivitetskode',
        marketing_activity_name: 'Navn på markedsføringsaktivitet',
        vehicle_warranty_period: 'Køretøjsgarantiperiode',
        marketing_activities: 'Markedsføringsaktiviteter',
        prohibition_of_claims: 'Forbud mod krav',
        prohibited_claim_code: 'Kode for forbudt krav',
        type_of_warranty_period: 'Type af garantiperiode',
        repair_end_date: 'Reparationsslutdato',
        reception_date: 'Modtagelsesdato',
        main_station_code: 'Hovedstationskode',
        main_workstation_name: 'Navn på hovedarbejdsplads',
        smvp_initiator: 'SMVP-initiativtager',
        contact_email: 'SMVP-kontaktmail',
        ssnw_doc_no: 'SSNW-dokumentnummer',
        gws_doc_no: 'GWS-dokumentnummer',
        missing_doc_reason: 'Årsag til manglende dokumentnummer',
        part_return_no: 'Reservedel-retur-nummer',
        part_price: 'Reservedelspris ($)',
        return_info: 'Returoplysninger',
        add_part: 'Tilføj reservedel',
        initiate_part_return: 'Start reservedelsretur',
        domestic_return_form: 'Indenlandsk returskema',
        confirm_part_received: 'Bekræft modtagelse af reservedel',
        submit_analysis_report: 'Indsend analyse rapport',
        fill_domestic_return_form: 'Udfyld indenlandsk returskema',
        view_overseas_return_info: 'Se oplysninger om udenlandsk retur',
        confirm_domestic_part_return: 'Bekræft indenlandsk reservedelsretur',
        issue: 'Udsted',
        fill_overseas_return_form: 'Udfyld udenlandsk returskema',
        confirm_overseas_part_return: 'Bekræft udenlandsk reservedelsretur',
        view_overseas_return_form: 'Se udenlandsk returskema',
        reject_reason: 'Afvisningsårsag',
        choose_part: 'Vælg reservedel',
        express_tracking_number: 'Express sporingnummer',
        auditor: 'Revisor',
        recipient: 'Modtager',
        pickup_date: 'Afhentningsdato for kurér',
        consignee: 'Modtager',
        consignee_company: 'Modtagerfirma',
        delivery_address: 'Leveringsadresse',
        consignee_phone: 'Modtagerens telefon',
        shipper: 'Afsender',
        shipper_company: 'Afsenderfirma',
        address: 'Adresse',
        country_of_origin: 'Oprindelsesland',
        total_price: 'Samlet pris ($)',
        analysis_rejection_reason: 'Årsag til afvisning af analyse',
        export_invoice: 'Eksportér faktura',
        dhl_confirm_auth: 'DHL-bekræftelse af autorisation',
        reject_return_warning: 'Afvisning af retur kan medføre fradrag i kravbeløbet',
        use_consignee_account_tip:
            'Brug af modtagerens konto til forsendelse kræver deres tilladelse; angiv venligst den e-mail, der skal bruges til forsendelse',
    },
    // 芬兰语
    fiFI: {
        vin: 'VIN',
        claim_information: 'Vahingonkorvaustiedot',
        marketing_activity_list: 'Markkinointitoimien luettelo',
        basic_information: 'Perustiedot',
        warranty_block: 'Takuulohko',
        repair_block_code: 'Korjauslohkon koodi',
        claim_cycle_list: 'Korvausjaksojen luettelo',
        WTY_Indicates_the_cycle_type: 'WTY-jakson tyyppi',
        start_time: 'Alkuaika',
        end_time: 'Päättymisaika',
        WTY_mileage: 'WTY-kilometrimäärä',
        List_of_claims: 'Korvauslistaus',
        customer: 'Asiakas',
        warranty_claim: 'Takuukorvaus',
        work_order: 'Työtilaus',
        date_of_receipt: 'Vastaanottopäivämäärä',
        maintenance_technical_date: 'Huoltotekninen päivämäärä',
        mileage: 'Ajokilometrit',
        state: 'Tila',
        main_component: 'Pääkomponentti',
        part_name: 'Osan nimi',
        Recall_and_service_activities: 'Palautus- ja huoltoaktiviteetit',
        recall_and_service_activity_code: 'Palautus- ja huoltoaktiviteetin koodi',
        recall_and_service_activity_names: 'Palautus- ja huoltoaktiviteettien nimet',
        brand: 'Merkki',
        recall_type_code: 'Huollon tyyppikoodi',
        recall_type_name: 'Huollon tyyppinimi',
        release_date: 'Julkaisupäivämäärä',
        closing_date: 'Sulkemispäivämäärä',
        complete: 'Valmis',
        warranty_claim_status: 'Takuukorvauksen tila',
        end_of_maintenance_date: 'Huollon päättymispäivämäärä',
        marketing_activity_code: 'Markkinointitoimen koodi',
        marketing_activity_name: 'Markkinointitoimen nimi',
        vehicle_warranty_period: 'Ajoneuvon takuuaika',
        marketing_activities: 'Markkinointitoimet',
        prohibition_of_claims: 'Korvausten kieltäminen',
        prohibited_claim_code: 'Kielletyn korvauksen koodi',
        type_of_warranty_period: 'Takuuajan tyyppi',
        repair_end_date: 'Korjauksen päättymispäivämäärä',
        reception_date: 'Vastaanottopäivämäärä',
        main_station_code: 'Pääaseman koodi',
        main_workstation_name: 'Päätyöpisteen nimi',
        smvp_initiator: 'SMVP:n aloittaja',
        contact_email: 'SMVP-yhteyshenkilön sähköposti',
        ssnw_doc_no: 'SSNW-asiakirjan numero',
        gws_doc_no: 'GWS-asiakirjan numero',
        missing_doc_reason: 'Asiakirjanumeron puuttumisen syy',
        part_return_no: 'Osan palautusnumero',
        part_price: 'Osan hinta ($)',
        return_info: 'Palautustiedot',
        add_part: 'Lisää osa',
        initiate_part_return: 'Aloita osan palautus',
        domestic_return_form: 'Kotimainen palautuslomake',
        confirm_part_received: 'Vahvista osan vastaanotto',
        submit_analysis_report: 'Lähetä analyysiraportti',
        fill_domestic_return_form: 'Täytä kotimainen palautuslomake',
        view_overseas_return_info: 'Näytä ulkomaisten palautusten tiedot',
        confirm_domestic_part_return: 'Vahvista kotimainen osan palautus',
        issue: 'Myönnä',
        fill_overseas_return_form: 'Täytä ulkomainen palautuslomake',
        confirm_overseas_part_return: 'Vahvista ulkomainen osan palautus',
        view_overseas_return_form: 'Näytä ulkomainen palautuslomake',
        reject_reason: 'Hylkäämisen syy',
        choose_part: 'Valitse osa',
        express_tracking_number: 'Pikatoimituksen seurantakoodi',
        auditor: 'Tarkastaja',
        recipient: 'Vastaanottaja',
        pickup_date: 'Pakettiauton noutopäivämäärä',
        consignee: 'Vastaanottaja',
        consignee_company: 'Vastaanottajan yritys',
        delivery_address: 'Toimitusosoite',
        consignee_phone: 'Vastaanottajan puhelinnumero',
        shipper: 'Lähettäjä',
        shipper_company: 'Lähettäjän yritys',
        address: 'Osoite',
        country_of_origin: 'Alkuperämaa',
        total_price: 'Yhteishinta ($)',
        analysis_rejection_reason: 'Analyysin hylkäämisen syy',
        export_invoice: 'Vie lasku',
        dhl_confirm_auth: 'DHL-valtuutuksen vahvistus',
        reject_return_warning: 'Palautuksen hylkääminen saattaa johtaa korvaussumman vähennykseen',
        use_consignee_account_tip:
            'Vastaanottajan tilin käyttö lähetystä varten vaatii heidän valtuutuksensa; anna lähetyskäytössä oleva sähköpostiosoite',
    },
    // 繁体中文台湾
    zhTW: {
        vin: 'VIN',
        claim_information: '索賠資訊',
        marketing_activity_list: '行銷活動列表',
        basic_information: '基本資訊',
        warranty_block: '保固區塊',
        repair_block_code: '保固區塊代碼',
        claim_cycle_list: '索賠週期列表',
        WTY_Indicates_the_cycle_type: 'WTY週期類型',
        start_time: '開始時間',
        end_time: '結束時間',
        WTY_mileage: 'WTY里程',
        List_of_claims: '索賠單列表',
        customer: '顧客',
        warranty_claim: '保固索賠單',
        work_order: '工單',
        date_of_receipt: '接收日期',
        maintenance_technical_date: '維修技術日期',
        mileage: '里程',
        state: '狀態',
        main_component: '主要部件',
        part_name: '零件名稱',
        Recall_and_service_activities: '召回與服務活動',
        recall_and_service_activity_code: '召回與服務活動代碼',
        recall_and_service_activity_names: '召回與服務活動名稱',
        brand: '品牌',
        recall_type_code: '服務類型代碼',
        recall_type_name: '服務類型名稱',
        release_date: '發布日期',
        closing_date: '關閉日期',
        complete: '完成',
        warranty_claim_status: '保固索賠狀態',
        end_of_maintenance_date: '維修結束日期',
        marketing_activity_code: '市場活動代碼',
        marketing_activity_name: '市場活動名稱',
        vehicle_warranty_period: '車輛保固期',
        marketing_activities: '市場活動',
        prohibition_of_claims: '禁止索賠',
        prohibited_claim_code: '禁止索賠代碼',
        type_of_warranty_period: '保固期類型',
        repair_end_date: '維修結束日期',
        reception_date: '接待日期',
        main_station_code: '主工位代碼',
        main_workstation_name: '主工位名稱',
        smvp_initiator: 'SMPV發起人',
        contact_email: 'SMPV聯絡信箱',
        ssnw_doc_no: 'SSNW單據號',
        gws_doc_no: 'GWS單據號',
        missing_doc_reason: '單據號缺失原因',
        part_return_no: '零件回運單號',
        part_price: '零件價格($)',
        return_info: '回運資訊',
        add_part: '新增零件',
        initiate_part_return: '發起零件回運',
        domestic_return_form: '國內回運單',
        confirm_part_received: '確認零件簽收',
        submit_analysis_report: '提交分析報告',
        fill_domestic_return_form: '填寫國內回運單',
        view_overseas_return_info: '查看回運單資訊',
        confirm_domestic_part_return: '確認國內零件回運',
        issue: '下發',
        fill_overseas_return_form: '填寫回運單',
        confirm_overseas_part_return: '確認零件回運',
        view_overseas_return_form: '查看回運單',
        reject_reason: '拒絕原因',
        choose_part: '選擇零件',
        express_tracking_number: '快遞單號',
        auditor: '審核人',
        recipient: '下發對象',
        pickup_date: '快遞取件日期',
        consignee: '收貨人',
        consignee_company: '收貨人公司',
        delivery_address: '收貨地址',
        consignee_phone: '收貨人電話',
        shipper: '發貨人',
        shipper_company: '發貨人公司',
        address: '住址',
        country_of_origin: '原產國',
        total_price: '總價($)',
        analysis_rejection_reason: '分析結果拒絕原因',
        export_invoice: '匯出發票',
        dhl_confirm_auth: 'DHL確認授權',
        reject_return_warning: '拒絕回運可能會扣除索賠款',
        use_consignee_account_tip: '使用收件方帳號寄件需對方授權，請提供寄件用電子信箱',
    },
    // 克罗地亚
    hrHR: {
        vin: 'VIN',
        claim_information: 'Informacije o zahtjevu',
        marketing_activity_list: 'Popis marketinških aktivnosti',
        basic_information: 'Osnovne informacije',
        warranty_block: 'Jamstveni blok',
        repair_block_code: 'Kôd jamstvenog bloka',
        claim_cycle_list: 'Popis ciklusa zahtjeva',
        WTY_Indicates_the_cycle_type: 'Vrsta WTY ciklusa',
        start_time: 'Vrijeme početka',
        end_time: 'Vrijeme završetka',
        WTY_mileage: 'WTY kilometraža',
        List_of_claims: 'Popis zahtjeva',
        customer: 'Kupac',
        warranty_claim: 'Jamstveni zahtjev',
        work_order: 'Radni nalog',
        date_of_receipt: 'Datum prijema',
        maintenance_technical_date: 'Tehnički datum održavanja',
        mileage: 'Kilometraža',
        state: 'Stanje',
        main_component: 'Glavna komponenta',
        part_name: 'Naziv dijela',
        Recall_and_service_activities: 'Aktivnosti povlačenja i servisa',
        recall_and_service_activity_code: 'Kôd aktivnosti povlačenja i servisa',
        recall_and_service_activity_names: 'Nazivi aktivnosti povlačenja i servisa',
        brand: 'Marka',
        recall_type_code: 'Kôd vrste usluge',
        recall_type_name: 'Naziv vrste usluge',
        release_date: 'Datum objave',
        closing_date: 'Datum zatvaranja',
        complete: 'Završeno',
        warranty_claim_status: 'Status jamstvenog zahtjeva',
        end_of_maintenance_date: 'Datum završetka održavanja',
        marketing_activity_code: 'Kôd marketinške aktivnosti',
        marketing_activity_name: 'Naziv marketinške aktivnosti',
        vehicle_warranty_period: 'Razdoblje jamstva vozila',
        marketing_activities: 'Marketinške aktivnosti',
        prohibition_of_claims: 'Zabranjeni zahtjevi',
        prohibited_claim_code: 'Kôd zabranjenog zahtjeva',
        type_of_warranty_period: 'Vrsta jamstvenog razdoblja',
        repair_end_date: 'Datum završetka popravka',
        reception_date: 'Datum prijema',
        main_station_code: 'Kôd glavne stanice',
        main_workstation_name: 'Naziv glavne radne stanice',
        smvp_initiator: 'Inicijator SMVP-a',
        contact_email: 'Kontakt e-mail za SMVP',
        ssnw_doc_no: 'Broj SSNW dokumenta',
        gws_doc_no: 'Broj GWS dokumenta',
        missing_doc_reason: 'Razlog nedostatka broja dokumenta',
        part_return_no: 'Broj povratnice dijela',
        part_price: 'Cijena dijela ($)',
        return_info: 'Informacije o povratu',
        add_part: 'Dodaj dio',
        initiate_part_return: 'Pokreni povrat dijela',
        domestic_return_form: 'Obrazac za domaći povrat',
        confirm_part_received: 'Potvrdi prijem dijela',
        submit_analysis_report: 'Podnesi izvješće o analizi',
        fill_domestic_return_form: 'Ispuni obrazac za domaći povrat',
        view_overseas_return_info: 'Pregled informacija o inozemnom povratu',
        confirm_domestic_part_return: 'Potvrdi domaći povrat dijela',
        issue: 'Izdaj',
        fill_overseas_return_form: 'Ispuni obrazac za inozemni povrat',
        confirm_overseas_part_return: 'Potvrdi inozemni povrat dijela',
        view_overseas_return_form: 'Pregled obrasca za inozemni povrat',
        reject_reason: 'Razlog odbijanja',
        choose_part: 'Odaberi dio',
        express_tracking_number: 'Broj za praćenje kurirske pošiljke',
        auditor: 'Revizor',
        recipient: 'Primatelj',
        pickup_date: 'Datum preuzimanja kurira',
        consignee: 'Primatelj pošiljke',
        consignee_company: 'Tvrtka primatelja',
        delivery_address: 'Adresa isporuke',
        consignee_phone: 'Telefon primatelja',
        shipper: 'Pošiljatelj',
        shipper_company: 'Tvrtka pošiljatelja',
        address: 'Adresa',
        country_of_origin: 'Zemlja podrijetla',
        total_price: 'Ukupna cijena ($)',
        analysis_rejection_reason: 'Razlog odbijanja analize',
        export_invoice: 'Izvoz računa',
        dhl_confirm_auth: 'Potvrda ovlasti od DHL-a',
        reject_return_warning: 'Odbijanje povrata može rezultirati odbitkom iznosа zahtjeva',
        use_consignee_account_tip:
            'Korištenje računa primatelja za slanje zahtijeva njihovu ovlast; navedite e-mail koji će se koristiti za slanje',
    },
    // 拉脱维亚
    lvLV: {
        vin: 'VIN',
        claim_information: 'Prasības informācija',
        marketing_activity_list: 'Mārketinga aktivitāšu saraksts',
        basic_information: 'Pamatinformācija',
        warranty_block: 'Garantijas bloks',
        repair_block_code: 'Remonta bloka kods',
        claim_cycle_list: 'Prasību ciklu saraksts',
        WTY_Indicates_the_cycle_type: 'WTY cikla veids',
        start_time: 'Sākuma laiks',
        end_time: 'Beigu laiks',
        WTY_mileage: 'WTY nobraukums',
        List_of_claims: 'Prasību saraksts',
        customer: 'Klients',
        warranty_claim: 'Garantijas prasība',
        work_order: 'Darba pasūtījums',
        date_of_receipt: 'Saņemšanas datums',
        maintenance_technical_date: 'Tehniskās apkopes datums',
        mileage: 'Nobraukums',
        state: 'Statuss',
        main_component: 'Galvenā sastāvdaļa',
        part_name: 'Detaļas nosaukums',
        Recall_and_service_activities: 'Atsaukšanas un servisa aktivitātes',
        recall_and_service_activity_code: 'Atsaukšanas un servisa aktivitātes kods',
        recall_and_service_activity_names: 'Atsaukšanas un servisa aktivitāšu nosaukumi',
        brand: 'Zīmols',
        recall_type_code: 'Servisa veida kods',
        recall_type_name: 'Servisa veida nosaukums',
        release_date: 'Izlaišanas datums',
        closing_date: 'Slēgšanas datums',
        complete: 'Pabeigts',
        warranty_claim_status: 'Garantijas prasības statuss',
        end_of_maintenance_date: 'Apkopē beigu datums',
        marketing_activity_code: 'Mārketinga aktivitātes kods',
        marketing_activity_name: 'Mārketinga aktivitātes nosaukums',
        vehicle_warranty_period: 'Transportlīdzekļa garantijas periods',
        marketing_activities: 'Mārketinga aktivitātes',
        prohibition_of_claims: 'Prasību aizliegums',
        prohibited_claim_code: 'Aizliegtās prasības kods',
        type_of_warranty_period: 'Garantijas perioda veids',
        repair_end_date: 'Remonta beigu datums',
        reception_date: 'Uzņemšanas datums',
        main_station_code: 'Galvenā stacijas kods',
        main_workstation_name: 'Galvenā darba vietas nosaukums',
        smvp_initiator: 'SMVP iniciators',
        contact_email: 'SMVP kontaktēšanās e-pasts',
        ssnw_doc_no: 'SSNW dokumenta numurs',
        gws_doc_no: 'GWS dokumenta numurs',
        missing_doc_reason: 'Dokumenta numura trūkuma iemesls',
        part_return_no: 'Detaļas atgriešanas numurs',
        part_price: 'Detaļas cena ($)',
        return_info: 'Atgriešanas informācija',
        add_part: 'Pievienot detaļu',
        initiate_part_return: 'Iniciēt detaļas atgriešanu',
        domestic_return_form: 'Iekšzemes atgriešanas veidlapa',
        confirm_part_received: 'Apstiprināt detaļas saņemšanu',
        submit_analysis_report: 'Iesniegt analīzes ziņojumu',
        fill_domestic_return_form: 'Aizpildīt iekšzemes atgriešanas veidlapu',
        view_overseas_return_info: 'Skatīt ārvalstu atgriešanas informāciju',
        confirm_domestic_part_return: 'Apstiprināt iekšzemes detaļas atgriešanu',
        issue: 'Izdot',
        fill_overseas_return_form: 'Aizpildīt ārvalstu atgriešanas veidlapu',
        confirm_overseas_part_return: 'Apstiprināt ārvalstu detaļas atgriešanu',
        view_overseas_return_form: 'Skatīt ārvalstu atgriešanas veidlapu',
        reject_reason: 'Noraidījuma iemesls',
        choose_part: 'Izvēlēties detaļu',
        express_tracking_number: 'Ekspreskurjera izsekošanas numurs',
        auditor: 'Revizors',
        recipient: 'Saņēmējs',
        pickup_date: 'Kurjera piegādes datums',
        consignee: 'Saņēmējs',
        consignee_company: 'Saņēmēja uzņēmums',
        delivery_address: 'Piegādes adrese',
        consignee_phone: 'Saņēmēja tālrunis',
        shipper: 'Sūtītājs',
        shipper_company: 'Sūtītāja uzņēmums',
        address: 'Adrese',
        country_of_origin: 'Izcelsmes valsts',
        total_price: 'Kopējā cena ($)',
        analysis_rejection_reason: 'Analīzes noraidījuma iemesls',
        export_invoice: 'Eksportēt rēķinu',
        dhl_confirm_auth: 'DHL pilnvaras apstiprinājums',
        reject_return_warning: 'Atgriešanas atteikšana var izraisīt prasījuma summas atskaitīšanu',
        use_consignee_account_tip:
            'Saņēmēja konta izmantošana sūtīšanai prasa viņu pilnvaru; lūdzu, norādiet e-pastu, kas tiks izmantots sūtīšanai',
    },
    // 立陶宛
    ltLT: {
        vin: 'VIN',
        claim_information: 'Pareikalavimo informacija',
        marketing_activity_list: 'Rinkodaros veiklų sąrašas',
        basic_information: 'Pagrindinė informacija',
        warranty_block: 'Garantinis blokas',
        repair_block_code: 'Remonto bloko kodas',
        claim_cycle_list: 'Pareikalavimų ciklų sąrašas',
        WTY_Indicates_the_cycle_type: 'WTY ciklo tipas',
        start_time: 'Pradžios laikas',
        end_time: 'Pabaigos laikas',
        WTY_mileage: 'WTY ridos kilometrai',
        List_of_claims: 'Pareikalavimų sąrašas',
        customer: 'Klientas',
        warranty_claim: 'Garantinis pareikalavimas',
        work_order: 'Darbo užsakymas',
        date_of_receipt: 'Gavimo data',
        maintenance_technical_date: 'Techninės priežiūros data',
        mileage: 'Rida',
        state: 'Būsena',
        main_component: 'Pagrindinė dalis',
        part_name: 'Detalės pavadinimas',
        Recall_and_service_activities: 'Atšaukimo ir aptarnavimo veiklos',
        recall_and_service_activity_code: 'Atšaukimo ir aptarnavimo veiklos kodas',
        recall_and_service_activity_names: 'Atšaukimo ir aptarnavimo veiklų pavadinimai',
        brand: 'Prekės ženklas',
        recall_type_code: 'Paslaugos tipo kodas',
        recall_type_name: 'Paslaugos tipo pavadinimas',
        release_date: 'Išleidimo data',
        closing_date: 'Uždarymo data',
        complete: 'Užbaigta',
        warranty_claim_status: 'Garantinio pareikalavimo būsena',
        end_of_maintenance_date: 'Priežiūros pabaigos data',
        marketing_activity_code: 'Rinkodaros veiklos kodas',
        marketing_activity_name: 'Rinkodaros veiklos pavadinimas',
        vehicle_warranty_period: 'Transporto priemonės garantinis laikotarpis',
        marketing_activities: 'Rinkodaros veiklos',
        prohibition_of_claims: 'Pareikalavimų draudimas',
        prohibited_claim_code: 'Draudžiamo pareikalavimo kodas',
        type_of_warranty_period: 'Garantinio laikotarpio tipas',
        repair_end_date: 'Remonto pabaigos data',
        reception_date: 'Priėmimo data',
        main_station_code: 'Pagrindinės stoties kodas',
        main_workstation_name: 'Pagrindinės darbo vietos pavadinimas',
        smvp_initiator: 'SMVP iniciatorius',
        contact_email: 'SMVP kontaktinis el. paštas',
        ssnw_doc_no: 'SSNW dokumento numeris',
        gws_doc_no: 'GWS dokumento numeris',
        missing_doc_reason: 'Dokumento numerio trūkumo priežastis',
        part_return_no: 'Detalės grąžinimo numeris',
        part_price: 'Detalės kaina ($)',
        return_info: 'Grąžinimo informacija',
        add_part: 'Pridėti detalę',
        initiate_part_return: 'Inicijuoti detalės grąžinimą',
        domestic_return_form: 'Vidinio grąžinimo forma',
        confirm_part_received: 'Patvirtinti detalės gavimą',
        submit_analysis_report: 'Pateikti analizės ataskaitą',
        fill_domestic_return_form: 'Užpildyti vidinio grąžinimo formą',
        view_overseas_return_info: 'Peržiūrėti užsienio grąžinimo informaciją',
        confirm_domestic_part_return: 'Patvirtinti vidinį detalės grąžinimą',
        issue: 'Išleisti',
        fill_overseas_return_form: 'Užpildyti užsienio grąžinimo formą',
        confirm_overseas_part_return: 'Patvirtinti užsienio detalės grąžinimą',
        view_overseas_return_form: 'Peržiūrėti užsienio grąžinimo formą',
        reject_reason: 'Atmetimo priežastis',
        choose_part: 'Pasirinkti detalę',
        express_tracking_number: 'Kurjerio sekimo numeris',
        auditor: 'Auditorius',
        recipient: 'Gavėjas',
        pickup_date: 'Kurjerio atsiėmimo data',
        consignee: 'Gavėjas',
        consignee_company: 'Gavėjo įmonė',
        delivery_address: 'Pristatymo adresas',
        consignee_phone: 'Gavėjo telefonas',
        shipper: 'Siuntėjas',
        shipper_company: 'Siuntėjo įmonė',
        address: 'Adresas',
        country_of_origin: 'Kilmės šalis',
        total_price: 'Bendra kaina ($)',
        analysis_rejection_reason: 'Analizės atmetimo priežastis',
        export_invoice: 'Eksportuoti sąskaitą',
        dhl_confirm_auth: 'DHL patvirtinimas dėl įgaliojimo',
        reject_return_warning: 'Atsisakant grąžinti, gali būti sumažinta pareikalavimo suma',
        use_consignee_account_tip:
            'Naudojant gavėjo paskyrą siuntimui, reikia jo įgaliojimo; prašome pateikti siuntimui naudojamą el. paštą',
    },
    // 罗马尼亚
    roRO: {
        vin: 'VIN',
        claim_information: 'Informații despre solicitare',
        marketing_activity_list: 'Listă activități de marketing',
        basic_information: 'Informații de bază',
        warranty_block: 'Bloc garanție',
        repair_block_code: 'Cod bloc reparație',
        claim_cycle_list: 'Listă cicluri solicitări',
        WTY_Indicates_the_cycle_type: 'Tip ciclu WTY',
        start_time: 'Data începerii',
        end_time: 'Data încheierii',
        WTY_mileage: 'Kilometraj WTY',
        List_of_claims: 'Listă solicitări',
        customer: 'Client',
        warranty_claim: 'Solicitare garanție',
        work_order: 'Ordin de lucru',
        date_of_receipt: 'Data primirii',
        maintenance_technical_date: 'Data tehnică de întreținere',
        mileage: 'Kilometraj',
        state: 'Stare',
        main_component: 'Componentă principală',
        part_name: 'Denumire piesă',
        Recall_and_service_activities: 'Activități de retragere și service',
        recall_and_service_activity_code: 'Cod activitate retragere și service',
        recall_and_service_activity_names: 'Denumiri activități retragere și service',
        brand: 'Marcă',
        recall_type_code: 'Cod tip service',
        recall_type_name: 'Denumire tip service',
        release_date: 'Data lansării',
        closing_date: 'Data închiderii',
        complete: 'Finalizat',
        warranty_claim_status: 'Stare solicitare garanție',
        end_of_maintenance_date: 'Data finalizării întreținerii',
        marketing_activity_code: 'Cod activitate marketing',
        marketing_activity_name: 'Denumire activitate marketing',
        vehicle_warranty_period: 'Perioadă garanție vehicul',
        marketing_activities: 'Activități de marketing',
        prohibition_of_claims: 'Interzicere solicitări',
        prohibited_claim_code: 'Cod solicitare interzisă',
        type_of_warranty_period: 'Tip perioadă garanție',
        repair_end_date: 'Data finalizării reparației',
        reception_date: 'Data recepției',
        main_station_code: 'Cod stație principală',
        main_workstation_name: 'Denumire stație principală',
        smvp_initiator: 'Inițiator SMVP',
        contact_email: 'Email contact SMVP',
        ssnw_doc_no: 'Număr document SSNW',
        gws_doc_no: 'Număr document GWS',
        missing_doc_reason: 'Motiv lipsă număr document',
        part_return_no: 'Număr retur piesă',
        part_price: 'Preț piesă ($)',
        return_info: 'Informații retur',
        add_part: 'Adaugă piesă',
        initiate_part_return: 'Inițiază retur piesă',
        domestic_return_form: 'Formular retur intern',
        confirm_part_received: 'Confirmă primirea piesei',
        submit_analysis_report: 'Trimite raport analiză',
        fill_domestic_return_form: 'Completează formular retur intern',
        view_overseas_return_info: 'Vizualizează informații retur extern',
        confirm_domestic_part_return: 'Confirmă retur intern piesă',
        issue: 'Emitere',
        fill_overseas_return_form: 'Completează formular retur extern',
        confirm_overseas_part_return: 'Confirmă retur extern piesă',
        view_overseas_return_form: 'Vizualizează formular retur extern',
        reject_reason: 'Motiv respingere',
        choose_part: 'Alege piesă',
        express_tracking_number: 'Număr urmărire curier',
        auditor: 'Auditor',
        recipient: 'Destinatar',
        pickup_date: 'Data ridicării de către curier',
        consignee: 'Destinatar',
        consignee_company: 'Companie destinatar',
        delivery_address: 'Adresă livrare',
        consignee_phone: 'Telefon destinatar',
        shipper: 'Expeditor',
        shipper_company: 'Companie expeditor',
        address: 'Adresă',
        country_of_origin: 'Țară de origine',
        total_price: 'Preț total ($)',
        analysis_rejection_reason: 'Motiv respingere analiză',
        export_invoice: 'Exportă factură',
        dhl_confirm_auth: 'Confirmare autorizație DHL',
        reject_return_warning: 'Respingerea returului poate duce la deducerea sumei solicitate',
        use_consignee_account_tip:
            'Folosirea contului destinatarului pentru expediere necesită autorizarea acestuia; vă rugăm să furnizați emailul folosit pentru expediere',
    },
    // 挪威博克马尔
    nbNO: {
        vin: 'VIN',
        claim_information: 'Kravinformasjon',
        marketing_activity_list: 'Liste over markedsføringsaktiviteter',
        basic_information: 'Grunnleggende informasjon',
        warranty_block: 'Garantiblokk',
        repair_block_code: 'Reparasjonsblokkode',
        claim_cycle_list: 'Liste over kravsykluser',
        WTY_Indicates_the_cycle_type: 'WTY-syklustype',
        start_time: 'Starttidspunkt',
        end_time: 'Sluttidspunkt',
        WTY_mileage: 'WTY-kilometerstand',
        List_of_claims: 'Liste over krav',
        customer: 'Kunde',
        warranty_claim: 'Garantikrav',
        work_order: 'Arbeidsordre',
        date_of_receipt: 'Mottaksdato',
        maintenance_technical_date: 'Teknisk vedlikeholds dato',
        mileage: 'Kilometerstand',
        state: 'Status',
        main_component: 'Hovedkomponent',
        part_name: 'Delens navn',
        Recall_and_service_activities: 'Tilbakekall og serviceaktiviteter',
        recall_and_service_activity_code: 'Kode for tilbakekall og serviceaktivitet',
        recall_and_service_activity_names: 'Navn på tilbakekall og serviceaktiviteter',
        brand: 'Merke',
        recall_type_code: 'Servicetypekode',
        recall_type_name: 'Servicetypenavn',
        release_date: 'Utgivelsesdato',
        closing_date: 'Stengingsdato',
        complete: 'Fullført',
        warranty_claim_status: 'Status for garantikrav',
        end_of_maintenance_date: 'Sluttdato for vedlikehold',
        marketing_activity_code: 'Markedsføringsaktivitetskoden',
        marketing_activity_name: 'Navn på markedsføringsaktivitet',
        vehicle_warranty_period: 'Kjøretøygarantiperiode',
        marketing_activities: 'Markedsføringsaktiviteter',
        prohibition_of_claims: 'Forbud mot krav',
        prohibited_claim_code: 'Kode for forbudt krav',
        type_of_warranty_period: 'Type garantiperiode',
        repair_end_date: 'Reparasjonssluttdato',
        reception_date: 'Mottaksdato',
        main_station_code: 'Hovedstasjonskode',
        main_workstation_name: 'Navn på hovedarbeidsplass',
        smvp_initiator: 'SMVP-initiativtaker',
        contact_email: 'SMVP-kontakt e-post',
        ssnw_doc_no: 'SSNW-dokumentnummer',
        gws_doc_no: 'GWS-dokumentnummer',
        missing_doc_reason: 'Årsak til manglende dokumentnummer',
        part_return_no: 'Delretur-nummer',
        part_price: 'Delpris ($)',
        return_info: 'Returinformasjon',
        add_part: 'Legg til del',
        initiate_part_return: 'Start delretur',
        domestic_return_form: 'Innenlandsk returskjema',
        confirm_part_received: 'Bekreft mottak av del',
        submit_analysis_report: 'Send inn analyse rapport',
        fill_domestic_return_form: 'Fyll ut innenlandsk returskjema',
        view_overseas_return_info: 'Se informasjon om utenlandsk retur',
        confirm_domestic_part_return: 'Bekreft innenlandsk delretur',
        issue: 'Utsted',
        fill_overseas_return_form: 'Fyll ut utenlandsk returskjema',
        confirm_overseas_part_return: 'Bekreft utenlandsk delretur',
        view_overseas_return_form: 'Se utenlandsk returskjema',
        reject_reason: 'Avslagsgrunn',
        choose_part: 'Velg del',
        express_tracking_number: 'Ekspress sporingsnummer',
        auditor: 'Revisor',
        recipient: 'Mottaker',
        pickup_date: 'Hentested dato for bud',
        consignee: 'Mottaker',
        consignee_company: 'Mottakers firma',
        delivery_address: 'Leveringsadresse',
        consignee_phone: 'Mottakers telefon',
        shipper: 'Avsender',
        shipper_company: 'Avsenders firma',
        address: 'Adresse',
        country_of_origin: 'Opprinnelsesland',
        total_price: 'Totalpris ($)',
        analysis_rejection_reason: 'Årsak til avvisning av analyse',
        export_invoice: 'Eksporter faktura',
        dhl_confirm_auth: 'DHL-bekreftelse på autorisasjon',
        reject_return_warning: 'Avvisning av retur kan føre til fradrag i kravbeløpet',
        use_consignee_account_tip:
            'Bruk av mottakers konto for sending krever deres tillatelse; vennligst oppgi e-posten som skal brukes for sending',
    },
    // 葡萄牙语巴西
    ptBX: {
        vin: 'VIN',
        claim_information: 'Informações da reclamação',
        marketing_activity_list: 'Lista de atividades de marketing',
        basic_information: 'Informações básicas',
        warranty_block: 'Bloco de garantia',
        repair_block_code: 'Código do bloco de reparo',
        claim_cycle_list: 'Lista de ciclos de reclamação',
        WTY_Indicates_the_cycle_type: 'Tipo de ciclo WTY',
        start_time: 'Horário de início',
        end_time: 'Horário de término',
        WTY_mileage: 'Quilometragem WTY',
        List_of_claims: 'Lista de reclamações',
        customer: 'Cliente',
        warranty_claim: 'Reclamação de garantia',
        work_order: 'Ordem de serviço',
        date_of_receipt: 'Data de recebimento',
        maintenance_technical_date: 'Data técnica de manutenção',
        mileage: 'Quilometragem',
        state: 'Status',
        main_component: 'Componente principal',
        part_name: 'Nome da peça',
        Recall_and_service_activities: 'Atividades de recall e serviço',
        recall_and_service_activity_code: 'Código da atividade de recall e serviço',
        recall_and_service_activity_names: 'Nomes das atividades de recall e serviço',
        brand: 'Marca',
        recall_type_code: 'Código do tipo de serviço',
        recall_type_name: 'Nome do tipo de serviço',
        release_date: 'Data de lançamento',
        closing_date: 'Data de encerramento',
        complete: 'Concluído',
        warranty_claim_status: 'Status da reclamação de garantia',
        end_of_maintenance_date: 'Data de término da manutenção',
        marketing_activity_code: 'Código da atividade de marketing',
        marketing_activity_name: 'Nome da atividade de marketing',
        vehicle_warranty_period: 'Período de garantia do veículo',
        marketing_activities: 'Atividades de marketing',
        prohibition_of_claims: 'Proibição de reclamações',
        prohibited_claim_code: 'Código de reclamação proibida',
        type_of_warranty_period: 'Tipo de período de garantia',
        repair_end_date: 'Data de término do reparo',
        reception_date: 'Data de recepção',
        main_station_code: 'Código da estação principal',
        main_workstation_name: 'Nome da estação principal',
        smvp_initiator: 'Iniciador do SMVP',
        contact_email: 'E-mail de contato do SMVP',
        ssnw_doc_no: 'Número do documento SSNW',
        gws_doc_no: 'Número do documento GWS',
        missing_doc_reason: 'Motivo da ausência do número do documento',
        part_return_no: 'Número de devolução da peça',
        part_price: 'Preço da peça ($)',
        return_info: 'Informações de devolução',
        add_part: 'Adicionar peça',
        initiate_part_return: 'Iniciar devolução da peça',
        domestic_return_form: 'Formulário de devolução nacional',
        confirm_part_received: 'Confirmar recebimento da peça',
        submit_analysis_report: 'Enviar relatório de análise',
        fill_domestic_return_form: 'Preencher formulário de devolução nacional',
        view_overseas_return_info: 'Visualizar informações de devolução internacional',
        confirm_domestic_part_return: 'Confirmar devolução nacional da peça',
        issue: 'Emitir',
        fill_overseas_return_form: 'Preencher formulário de devolução internacional',
        confirm_overseas_part_return: 'Confirmar devolução internacional da peça',
        view_overseas_return_form: 'Visualizar formulário de devolução internacional',
        reject_reason: 'Motivo da recusa',
        choose_part: 'Escolher peça',
        express_tracking_number: 'Número de rastreamento expresso',
        auditor: 'Auditor',
        recipient: 'Destinatário',
        pickup_date: 'Data de coleta pelo correio',
        consignee: 'Destinatário',
        consignee_company: 'Empresa do destinatário',
        delivery_address: 'Endereço de entrega',
        consignee_phone: 'Telefone do destinatário',
        shipper: 'Remetente',
        shipper_company: 'Empresa do remetente',
        address: 'Endereço',
        country_of_origin: 'País de origem',
        total_price: 'Preço total ($)',
        analysis_rejection_reason: 'Motivo da recusa da análise',
        export_invoice: 'Exportar fatura',
        dhl_confirm_auth: 'Confirmação de autorização DHL',
        reject_return_warning:
            'Recusar a devolução pode resultar em desconto no valor da reclamação',
        use_consignee_account_tip:
            'Usar a conta do destinatário para envio requer autorização dele; por favor, forneça o e-mail a ser usado para envio',
    },
    // 瑞典语
    svSE: {
        vin: 'VIN',
        claim_information: 'Skadeanmälningsinformation',
        marketing_activity_list: 'Lista över marknadsföringsaktiviteter',
        basic_information: 'Grundläggande information',
        warranty_block: 'Garantiblock',
        repair_block_code: 'Reparationsblockkod',
        claim_cycle_list: 'Lista över ansökningscykler',
        WTY_Indicates_the_cycle_type: 'WTY-cykeltyp',
        start_time: 'Starttid',
        end_time: 'Sluttid',
        WTY_mileage: 'WTY-mätarställning',
        List_of_claims: 'Lista över ansökningar',
        customer: 'Kund',
        warranty_claim: 'Garantiansökan',
        work_order: 'Arbetsorder',
        date_of_receipt: 'Mottagandedatum',
        maintenance_technical_date: 'Tekniskt underhållsdatum',
        mileage: 'Mätarställning',
        state: 'Status',
        main_component: 'Huvudkomponent',
        part_name: 'Delnamn',
        Recall_and_service_activities: 'Återkallelse- och serviceaktiviteter',
        recall_and_service_activity_code: 'Kod för återkallelse- och serviceaktivitet',
        recall_and_service_activity_names: 'Namn på återkallelse- och serviceaktiviteter',
        brand: 'Märke',
        recall_type_code: 'Servicetypkod',
        recall_type_name: 'Servicetypnamn',
        release_date: 'Publiceringsdatum',
        closing_date: 'Stängningsdatum',
        complete: 'Slutförd',
        warranty_claim_status: 'Status för garantiansökan',
        end_of_maintenance_date: 'Underhållets sluttid',
        marketing_activity_code: 'Marknadsföringsaktivitetskod',
        marketing_activity_name: 'Namn på marknadsföringsaktivitet',
        vehicle_warranty_period: 'Fordons garanti period',
        marketing_activities: 'Marknadsföringsaktiviteter',
        prohibition_of_claims: 'Förbud mot ansökningar',
        prohibited_claim_code: 'Kod för förbjuden ansökan',
        type_of_warranty_period: 'Typ av garantiperiod',
        repair_end_date: 'Reparationens sluttid',
        reception_date: 'Mottagandedatum',
        main_station_code: 'Huvudstationskod',
        main_workstation_name: 'Namn på huvudarbetsplats',
        smvp_initiator: 'SMVP-initiativtagare',
        contact_email: 'SMVP-kontaktmejl',
        ssnw_doc_no: 'SSNW-dokumentnummer',
        gws_doc_no: 'GWS-dokumentnummer',
        missing_doc_reason: 'Anledning till saknat dokumentnummer',
        part_return_no: 'Delretur-nummer',
        part_price: 'Delpris ($)',
        return_info: 'Returinformation',
        add_part: 'Lägg till del',
        initiate_part_return: 'Initiera delretur',
        domestic_return_form: 'Inhemskt returformulär',
        confirm_part_received: 'Bekräfta mottagande av del',
        submit_analysis_report: 'Skicka in analysrapport',
        fill_domestic_return_form: 'Fyll i inhemskt returformulär',
        view_overseas_return_info: 'Visa information om utländsk retur',
        confirm_domestic_part_return: 'Bekräfta inhemska delreturen',
        issue: 'Utfärda',
        fill_overseas_return_form: 'Fyll i utländskt returformulär',
        confirm_overseas_part_return: 'Bekräfta utländsk delretur',
        view_overseas_return_form: 'Visa utländskt returformulär',
        reject_reason: 'Avslagsanledning',
        choose_part: 'Välj del',
        express_tracking_number: 'Express spårningsnummer',
        auditor: 'Revisor',
        recipient: 'Mottagare',
        pickup_date: 'Hämt datum för bud',
        consignee: 'Mottagare',
        consignee_company: 'Mottagarens företag',
        delivery_address: 'Leveransadress',
        consignee_phone: 'Mottagarens telefon',
        shipper: 'Avsändare',
        shipper_company: 'Avsändarens företag',
        address: 'Adress',
        country_of_origin: 'Ursprungsland',
        total_price: 'Totalsumma ($)',
        analysis_rejection_reason: 'Anledning till avvisning av analys',
        export_invoice: 'Exportera faktura',
        dhl_confirm_auth: 'DHL-bekräftelse på auktorisation',
        reject_return_warning: 'Att avvisa retur kan leda till avdrag på ansökningsbeloppet',
        use_consignee_account_tip:
            'Att använda mottagarens konto för försändelse kräver deras godkännande; ange mejladressen som ska användas för försändelsen',
    },
    // 斯洛伐克
    skSK: {
        vin: 'VIN',
        claim_information: 'Informácie o nároku',
        marketing_activity_list: 'Zoznam marketingových aktivít',
        basic_information: 'Základné informácie',
        warranty_block: 'Záručný blok',
        repair_block_code: 'Kód opravného bloku',
        claim_cycle_list: 'Zoznam cyklov nárokov',
        WTY_Indicates_the_cycle_type: 'Typ cyklu WTY',
        start_time: 'Dátum začiatku',
        end_time: 'Dátum ukončenia',
        WTY_mileage: 'Najazdené km WTY',
        List_of_claims: 'Zoznam nárokov',
        customer: 'Zákazník',
        warranty_claim: 'Záručný nárok',
        work_order: 'Pracovný príkaz',
        date_of_receipt: 'Dátum prijatia',
        maintenance_technical_date: 'Technický dátum údržby',
        mileage: 'Najazdené km',
        state: 'Stav',
        main_component: 'Hlavná súčiastka',
        part_name: 'Názov súčiastky',
        Recall_and_service_activities: 'Aktivity stiahnutia a servisu',
        recall_and_service_activity_code: 'Kód aktivity stiahnutia a servisu',
        recall_and_service_activity_names: 'Názvy aktivít stiahnutia a servisu',
        brand: 'Značka',
        recall_type_code: 'Kód typu služby',
        recall_type_name: 'Názov typu služby',
        release_date: 'Dátum vydania',
        closing_date: 'Dátum ukončenia',
        complete: 'Dokončené',
        warranty_claim_status: 'Stav záručného nároku',
        end_of_maintenance_date: 'Dátum ukončenia údržby',
        marketing_activity_code: 'Kód marketingovej aktivity',
        marketing_activity_name: 'Názov marketingovej aktivity',
        vehicle_warranty_period: 'Záručná lehota vozidla',
        marketing_activities: 'Marketingové aktivity',
        prohibition_of_claims: 'Zákaz nárokov',
        prohibited_claim_code: 'Kód zakázaného nároku',
        type_of_warranty_period: 'Typ záručnej lehoty',
        repair_end_date: 'Dátum ukončenia opravy',
        reception_date: 'Dátum prijatia',
        main_station_code: 'Kód hlavnej stanice',
        main_workstation_name: 'Názov hlavnej pracovnej stanice',
        smvp_initiator: 'Iniciátor SMVP',
        contact_email: 'Kontaktný e-mail SMVP',
        ssnw_doc_no: 'Číslo dokumentu SSNW',
        gws_doc_no: 'Číslo dokumentu GWS',
        missing_doc_reason: 'Dôvod chýbajúceho čísla dokumentu',
        part_return_no: 'Číslo vrátenia súčiastky',
        part_price: 'Cena súčiastky ($)',
        return_info: 'Informácie o vrátení',
        add_part: 'Pridať súčiastku',
        initiate_part_return: 'Spustiť vrátenie súčiastky',
        domestic_return_form: 'Formulár na domáce vrátenie',
        confirm_part_received: 'Potvrdiť prijatie súčiastky',
        submit_analysis_report: 'Odoslať správu o analýze',
        fill_domestic_return_form: 'Vyplniť formulár na domáce vrátenie',
        view_overseas_return_info: 'Zobraziť informácie o zahraničnom vrátení',
        confirm_domestic_part_return: 'Potvrdiť domáce vrátenie súčiastky',
        issue: 'Vydanie',
        fill_overseas_return_form: 'Vyplniť formulár na zahraničné vrátenie',
        confirm_overseas_part_return: 'Potvrdiť zahraničné vrátenie súčiastky',
        view_overseas_return_form: 'Zobraziť formulár na zahraničné vrátenie',
        reject_reason: 'Dôvod zamietnutia',
        choose_part: 'Vybrať súčiastku',
        express_tracking_number: 'Sledovacie číslo expresnej zásielky',
        auditor: 'Audítor',
        recipient: 'Príjemca',
        pickup_date: 'Dátum vyzdvihnutia zásielky kurírom',
        consignee: 'Príjemca',
        consignee_company: 'Spoločnosť príjemcu',
        delivery_address: 'Adresa doručenia',
        consignee_phone: 'Telefón príjemcu',
        shipper: 'Odosielateľ',
        shipper_company: 'Spoločnosť odosielateľa',
        address: 'Adresa',
        country_of_origin: 'Krajina pôvodu',
        total_price: 'Celková cena ($)',
        analysis_rejection_reason: 'Dôvod zamietnutia analýzy',
        export_invoice: 'Exportovať faktúru',
        dhl_confirm_auth: 'Potvrdenie autorizácie DHL',
        reject_return_warning: 'Zamietnutie vrátenia môže viesť k strhnutiu sumy nároku',
        use_consignee_account_tip:
            'Použitie účtu príjemcu na zasielanie vyžaduje ich autorizáciu; uveďte e-mail použitý na zasielanie',
    },
    // 斯洛文尼亚
    slSI: {
        vin: 'VIN',
        claim_information: 'Informacije o zahtevku',
        marketing_activity_list: 'Seznam marketinških aktivnosti',
        basic_information: 'Osnovne informacije',
        warranty_block: 'Garancijski blok',
        repair_block_code: 'Koda popravilnega bloka',
        claim_cycle_list: 'Seznam ciklov zahtevkov',
        WTY_Indicates_the_cycle_type: 'Vrsta WTY cikla',
        start_time: 'Začetni čas',
        end_time: 'Končni čas',
        WTY_mileage: 'Prevoženi kilometri WTY',
        List_of_claims: 'Seznam zahtevkov',
        customer: 'Stranka',
        warranty_claim: 'Garancijski zahtevek',
        work_order: 'Delovni nalog',
        date_of_receipt: 'Datum prejema',
        maintenance_technical_date: 'Tehnični datum vzdrževanja',
        mileage: 'Prevoženi kilometri',
        state: 'Stanje',
        main_component: 'Glavna komponenta',
        part_name: 'Ime dela',
        Recall_and_service_activities: 'Aktivnosti umika in servisa',
        recall_and_service_activity_code: 'Koda aktivnosti umika in servisa',
        recall_and_service_activity_names: 'Imena aktivnosti umika in servisa',
        brand: 'Znamka',
        recall_type_code: 'Koda vrste storitve',
        recall_type_name: 'Ime vrste storitve',
        release_date: 'Datum izdaje',
        closing_date: 'Datum zaprtja',
        complete: 'Dokončano',
        warranty_claim_status: 'Stanje garancijskega zahtevka',
        end_of_maintenance_date: 'Datum konca vzdrževanja',
        marketing_activity_code: 'Koda marketinške aktivnosti',
        marketing_activity_name: 'Ime marketinške aktivnosti',
        vehicle_warranty_period: 'Garancijsko obdobje vozila',
        marketing_activities: 'Marketinške aktivnosti',
        prohibition_of_claims: 'Prepoved zahtevkov',
        prohibited_claim_code: 'Koda prepovedanega zahtevka',
        type_of_warranty_period: 'Vrsta garancijskega obdobja',
        repair_end_date: 'Datum konca popravila',
        reception_date: 'Datum sprejema',
        main_station_code: 'Koda glavne postaje',
        main_workstation_name: 'Ime glavne delovne postaje',
        smvp_initiator: 'Iniciator SMVP',
        contact_email: 'Kontaktni e-naslov SMVP',
        ssnw_doc_no: 'Številka dokumenta SSNW',
        gws_doc_no: 'Številka dokumenta GWS',
        missing_doc_reason: 'Razlog za manjkajočo številko dokumenta',
        part_return_no: 'Številka vračila dela',
        part_price: 'Cena dela ($)',
        return_info: 'Informacije o vračilu',
        add_part: 'Dodaj del',
        initiate_part_return: 'Sproži vračilo dela',
        domestic_return_form: 'Obrazec za domače vračilo',
        confirm_part_received: 'Potrdi prejem dela',
        submit_analysis_report: 'Oddaj poročilo o analizi',
        fill_domestic_return_form: 'Izpolni obrazec za domače vračilo',
        view_overseas_return_info: 'Ogled informacij o tujem vračilu',
        confirm_domestic_part_return: 'Potrdi domače vračilo dela',
        issue: 'Izdaja',
        fill_overseas_return_form: 'Izpolni obrazec za tujem vračilo',
        confirm_overseas_part_return: 'Potrdi tujem vračilo dela',
        view_overseas_return_form: 'Ogled obrazca za tujem vračilo',
        reject_reason: 'Razlog za zavrnitev',
        choose_part: 'Izberi del',
        express_tracking_number: 'Sledilna številka hitrega dostave',
        auditor: 'Revizor',
        recipient: 'Prejemnik',
        pickup_date: 'Datum prevzema pošiljke s kurirjem',
        consignee: 'Prejemnik',
        consignee_company: 'Podjetje prejemnika',
        delivery_address: 'Naslov dostave',
        consignee_phone: 'Telefon prejemnika',
        shipper: 'Pošiljatelj',
        shipper_company: 'Podjetje pošiljatelja',
        address: 'Naslov',
        country_of_origin: 'Država izvora',
        total_price: 'Skupna cena ($)',
        analysis_rejection_reason: 'Razlog za zavrnitev analize',
        export_invoice: 'Izvozi račun',
        dhl_confirm_auth: 'Potrditev pooblastila DHL',
        reject_return_warning: 'Zavrnitev vračila lahko povzroči odbitek zneska zahtevka',
        use_consignee_account_tip:
            'Uporaba računa prejemnika za pošiljanje zahteva njihovo pooblastilo; navedite e-naslov, ki bo uporabljen za pošiljanje',
    },
    // 泰语
    thTH: {
        vin: 'VIN',
        claim_information: 'ข้อมูลการเคลม',
        marketing_activity_list: 'รายการกิจกรรมการตลาด',
        basic_information: 'ข้อมูลพื้นฐาน',
        warranty_block: 'บล็อกการรับประกัน',
        repair_block_code: 'รหัสบล็อกการซ่อม',
        claim_cycle_list: 'รายการรอบการเคลม',
        WTY_Indicates_the_cycle_type: 'ประเภทรอบ WTY',
        start_time: 'เวลาเริ่มต้น',
        end_time: 'เวลาสิ้นสุด',
        WTY_mileage: 'ระยะทาง WTY',
        List_of_claims: 'รายการเคลม',
        customer: 'ลูกค้า',
        warranty_claim: 'ใบเคลมประกัน',
        work_order: 'ใบสั่งงาน',
        date_of_receipt: 'วันที่รับ',
        maintenance_technical_date: 'วันที่ซ่อมบำรุงทางเทคนิค',
        mileage: 'ระยะทาง',
        state: 'สถานะ',
        main_component: 'ชิ้นส่วนหลัก',
        part_name: 'ชื่อชิ้นส่วน',
        Recall_and_service_activities: 'กิจกรรมเรียกคืนและบริการ',
        recall_and_service_activity_code: 'รหัสกิจกรรมเรียกคืนและบริการ',
        recall_and_service_activity_names: 'ชื่อกิจกรรมเรียกคืนและบริการ',
        brand: 'แบรนด์',
        recall_type_code: 'รหัสประเภทบริการ',
        recall_type_name: 'ชื่อประเภทบริการ',
        release_date: 'วันที่เผยแพร่',
        closing_date: 'วันที่ปิด',
        complete: 'เสร็จสมบูรณ์',
        warranty_claim_status: 'สถานะการเคลมประกัน',
        end_of_maintenance_date: 'วันที่สิ้นสุดการบำรุงรักษา',
        marketing_activity_code: 'รหัสกิจกรรมการตลาด',
        marketing_activity_name: 'ชื่อกิจกรรมการตลาด',
        vehicle_warranty_period: 'ระยะเวลาการรับประกันรถ',
        marketing_activities: 'กิจกรรมการตลาด',
        prohibition_of_claims: 'ห้ามเคลม',
        prohibited_claim_code: 'รหัสการเคลมที่ถูกห้าม',
        type_of_warranty_period: 'ประเภทระยะเวลาการรับประกัน',
        repair_end_date: 'วันที่สิ้นสุดการซ่อม',
        reception_date: 'วันที่รับเข้า',
        main_station_code: 'รหัสสถานีหลัก',
        main_workstation_name: 'ชื่อสถานีหลัก',
        smvp_initiator: 'ผู้ริเริ่ม SMVP',
        contact_email: 'อีเมลติดต่อ SMVP',
        ssnw_doc_no: 'หมายเลขเอกสาร SSNW',
        gws_doc_no: 'หมายเลขเอกสาร GWS',
        missing_doc_reason: 'เหตุผลที่ไม่มีหมายเลขเอกสาร',
        part_return_no: 'หมายเลขส่งคืนชิ้นส่วน',
        part_price: 'ราคาชิ้นส่วน ($)',
        return_info: 'ข้อมูลการส่งคืน',
        add_part: 'เพิ่มชิ้นส่วน',
        initiate_part_return: 'เริ่มต้นการส่งคืนชิ้นส่วน',
        domestic_return_form: 'แบบฟอร์มส่งคืนภายในประเทศ',
        confirm_part_received: 'ยืนยันการได้รับชิ้นส่วน',
        submit_analysis_report: 'ส่งรายงานการวิเคราะห์',
        fill_domestic_return_form: 'กรอกแบบฟอร์มส่งคืนภายในประเทศ',
        view_overseas_return_info: 'ดูข้อมูลการส่งคืนต่างประเทศ',
        confirm_domestic_part_return: 'ยืนยันการส่งคืนชิ้นส่วนภายในประเทศ',
        issue: 'ออก',
        fill_overseas_return_form: 'กรอกแบบฟอร์มส่งคืนต่างประเทศ',
        confirm_overseas_part_return: 'ยืนยันการส่งคืนชิ้นส่วน',
        view_overseas_return_form: 'ดูแบบฟอร์มส่งคืนต่างประเทศ',
        reject_reason: 'เหตุผลปฏิเสธ',
        choose_part: 'เลือกชิ้นส่วน',
        express_tracking_number: 'หมายเลขติดตามพัสดุ',
        auditor: 'ผู้ตรวจสอบ',
        recipient: 'ผู้รับ',
        pickup_date: 'วันที่รับพัสดุโดยผู้ให้บริการ',
        consignee: 'ผู้รับของ',
        consignee_company: 'บริษัทผู้รับของ',
        delivery_address: 'ที่อยู่จัดส่ง',
        consignee_phone: 'เบอร์โทรศัพท์ผู้รับของ',
        shipper: 'ผู้ส่ง',
        shipper_company: 'บริษัทผู้ส่ง',
        address: 'ที่อยู่',
        country_of_origin: 'ประเทศต้นทาง',
        total_price: 'ราคารวม ($)',
        analysis_rejection_reason: 'เหตุผลปฏิเสธผลการวิเคราะห์',
        export_invoice: 'ส่งออกใบแจ้งหนี้',
        dhl_confirm_auth: 'ยืนยันการอนุญาตจาก DHL',
        reject_return_warning: 'การปฏิเสธการส่งคืนอาจทำให้ถูกหักเงินเคลม',
        use_consignee_account_tip:
            'การใช้บัญชีผู้รับของในการส่งพัสดุจำเป็นต้องได้รับอนุญาตจากผู้รับของ กรุณาให้อีเมลที่ใช้ในการส่งพัสดุ',
    },
    // 乌克兰语
    ukUA: {
        vin: 'VIN',
        claim_information: 'Інформація про претензію',
        marketing_activity_list: 'Список маркетингових заходів',
        basic_information: 'Базова інформація',
        warranty_block: 'Гарантійний блок',
        repair_block_code: 'Код ремонтного блоку',
        claim_cycle_list: 'Список циклів претензій',
        WTY_Indicates_the_cycle_type: 'Тип циклу WTY',
        start_time: 'Час початку',
        end_time: 'Час завершення',
        WTY_mileage: 'Пробіг WTY',
        List_of_claims: 'Список претензій',
        customer: 'Клієнт',
        warranty_claim: 'Гарантійна претензія',
        work_order: 'Наряд-замовлення',
        date_of_receipt: 'Дата отримання',
        maintenance_technical_date: 'Технічна дата обслуговування',
        mileage: 'Пробіг',
        state: 'Стан',
        main_component: 'Основний компонент',
        part_name: 'Назва деталі',
        Recall_and_service_activities: 'Акції з відкликання та обслуговування',
        recall_and_service_activity_code: 'Код акції з відкликання та обслуговування',
        recall_and_service_activity_names: 'Назви акцій з відкликання та обслуговування',
        brand: 'Бренд',
        recall_type_code: 'Код типу послуги',
        recall_type_name: 'Назва типу послуги',
        release_date: 'Дата випуску',
        closing_date: 'Дата закриття',
        complete: 'Завершено',
        warranty_claim_status: 'Статус гарантійної претензії',
        end_of_maintenance_date: 'Дата завершення обслуговування',
        marketing_activity_code: 'Код маркетингової акції',
        marketing_activity_name: 'Назва маркетингової акції',
        vehicle_warranty_period: 'Термін гарантії автомобіля',
        marketing_activities: 'Маркетингові акції',
        prohibition_of_claims: 'Заборона претензій',
        prohibited_claim_code: 'Код забороненої претензії',
        type_of_warranty_period: 'Тип гарантійного періоду',
        repair_end_date: 'Дата завершення ремонту',
        reception_date: 'Дата прийому',
        main_station_code: 'Код головної станції',
        main_workstation_name: 'Назва головного робочого місця',
        smvp_initiator: 'Ініціатор SMVP',
        contact_email: 'Контактна електронна пошта SMVP',
        ssnw_doc_no: 'Номер документа SSNW',
        gws_doc_no: 'Номер документа GWS',
        missing_doc_reason: 'Причина відсутності номера документа',
        part_return_no: 'Номер повернення деталі',
        part_price: 'Ціна деталі ($)',
        return_info: 'Інформація про повернення',
        add_part: 'Додати деталь',
        initiate_part_return: 'Ініціювати повернення деталі',
        domestic_return_form: 'Форма внутрішнього повернення',
        confirm_part_received: 'Підтвердити отримання деталі',
        submit_analysis_report: 'Надіслати звіт про аналіз',
        fill_domestic_return_form: 'Заповнити форму внутрішнього повернення',
        view_overseas_return_info: 'Переглянути інформацію про міжнародне повернення',
        confirm_domestic_part_return: 'Підтвердити внутрішнє повернення деталі',
        issue: 'Видати',
        fill_overseas_return_form: 'Заповнити форму міжнародного повернення',
        confirm_overseas_part_return: 'Підтвердити міжнародне повернення деталі',
        view_overseas_return_form: 'Переглянути форму міжнародного повернення',
        reject_reason: 'Причина відмови',
        choose_part: 'Вибрати деталь',
        express_tracking_number: 'Номер відстеження експрес-доставки',
        auditor: 'Аудитор',
        recipient: 'Отримувач',
        pickup_date: 'Дата забору кур’єром',
        consignee: 'Отримувач',
        consignee_company: 'Компанія отримувача',
        delivery_address: 'Адреса доставки',
        consignee_phone: 'Телефон отримувача',
        shipper: 'Відправник',
        shipper_company: 'Компанія відправника',
        address: 'Адреса',
        country_of_origin: 'Країна походження',
        total_price: 'Загальна сума ($)',
        analysis_rejection_reason: 'Причина відмови від аналізу',
        export_invoice: 'Експортувати рахунок-фактуру',
        dhl_confirm_auth: 'Підтвердження авторизації DHL',
        reject_return_warning: 'Відмова від повернення може призвести до утримання суми претензії',
        use_consignee_account_tip:
            'Використання рахунку отримувача для відправлення вимагає його авторизації; будь ласка, надайте електронну пошту, яку буде використано для відправлення',
    },
    // 希腊语
    elGR: {
        vin: 'VIN',
        claim_information: 'Πληροφορίες αξίωσης',
        marketing_activity_list: 'Λίστα μάρκετινγκ δραστηριοτήτων',
        basic_information: 'Βασικές πληροφορίες',
        warranty_block: 'Μπλοκ εγγύησης',
        repair_block_code: 'Κωδικός μπλοκ επισκευής',
        claim_cycle_list: 'Λίστα κύκλων αξίωσης',
        WTY_Indicates_the_cycle_type: 'Τύπος κύκλου WTY',
        start_time: 'Ώρα έναρξης',
        end_time: 'Ώρα λήξης',
        WTY_mileage: 'Χιλιομετρική απόσταση WTY',
        List_of_claims: 'Λίστα αξιώσεων',
        customer: 'Πελάτης',
        warranty_claim: 'Αίτημα εγγύησης',
        work_order: 'Διαταγή εργασίας',
        date_of_receipt: 'Ημερομηνία παραλαβής',
        maintenance_technical_date: 'Τεχνική ημερομηνία συντήρησης',
        mileage: 'Χιλιομετρική απόσταση',
        state: 'Κατάσταση',
        main_component: 'Κύριο εξάρτημα',
        part_name: 'Όνομα εξαρτήματος',
        Recall_and_service_activities: 'Δραστηριότητες ανάκλησης και σέρβις',
        recall_and_service_activity_code: 'Κωδικός δραστηριότητας ανάκλησης και σέρβις',
        recall_and_service_activity_names: 'Ονόματα δραστηριοτήτων ανάκλησης και σέρβις',
        brand: 'Μάρκα',
        recall_type_code: 'Κωδικός τύπου υπηρεσίας',
        recall_type_name: 'Όνομα τύπου υπηρεσίας',
        release_date: 'Ημερομηνία κυκλοφορίας',
        closing_date: 'Ημερομηνία κλεισίματος',
        complete: 'Ολοκληρωμένο',
        warranty_claim_status: 'Κατάσταση αιτήματος εγγύησης',
        end_of_maintenance_date: 'Ημερομηνία λήξης συντήρησης',
        marketing_activity_code: 'Κωδικός δραστηριότητας μάρκετινγκ',
        marketing_activity_name: 'Όνομα δραστηριότητας μάρκετινγκ',
        vehicle_warranty_period: 'Περίοδος εγγύησης οχήματος',
        marketing_activities: 'Δραστηριότητες μάρκετινγκ',
        prohibition_of_claims: 'Απαγόρευση αξιώσεων',
        prohibited_claim_code: 'Κωδικός απαγορευμένης αξίωσης',
        type_of_warranty_period: 'Τύπος περιόδου εγγύησης',
        repair_end_date: 'Ημερομηνία λήξης επισκευής',
        reception_date: 'Ημερομηνία υποδοχής',
        main_station_code: 'Κωδικός κύριου σταθμού',
        main_workstation_name: 'Όνομα κύριου σταθμού εργασίας',
        smvp_initiator: 'Πρωτοβουλιακός φορέας SMVP',
        contact_email: 'Email επικοινωνίας SMVP',
        ssnw_doc_no: 'Αριθμός εγγράφου SSNW',
        gws_doc_no: 'Αριθμός εγγράφου GWS',
        missing_doc_reason: 'Αιτία έλλειψης αριθμού εγγράφου',
        part_return_no: 'Αριθμός επιστροφής εξαρτήματος',
        part_price: 'Τιμή εξαρτήματος ($)',
        return_info: 'Πληροφορίες επιστροφής',
        add_part: 'Προσθήκη εξαρτήματος',
        initiate_part_return: 'Έναρξη επιστροφής εξαρτήματος',
        domestic_return_form: 'Φόρμα επιστροφής εντός χώρας',
        confirm_part_received: 'Επιβεβαίωση παραλαβής εξαρτήματος',
        submit_analysis_report: 'Υποβολή αναφοράς ανάλυσης',
        fill_domestic_return_form: 'Συμπλήρωση φόρμας επιστροφής εντός χώρας',
        view_overseas_return_info: 'Προβολή πληροφοριών επιστροφής εξωτερικού',
        confirm_domestic_part_return: 'Επιβεβαίωση επιστροφής εξαρτήματος εντός χώρας',
        issue: 'Έκδοση',
        fill_overseas_return_form: 'Συμπλήρωση φόρμας επιστροφής εξωτερικού',
        confirm_overseas_part_return: 'Επιβεβαίωση επιστροφής εξαρτήματος',
        view_overseas_return_form: 'Προβολή φόρμας επιστροφής εξωτερικού',
        reject_reason: 'Αιτία απόρριψης',
        choose_part: 'Επιλογή εξαρτήματος',
        express_tracking_number: 'Αριθμός παρακολούθησης ταχυμεταφοράς',
        auditor: 'Ελεγκτής',
        recipient: 'Παραλήπτης',
        pickup_date: 'Ημερομηνία παραλαβής από ταχυμεταφορά',
        consignee: 'Παραλήπτης',
        consignee_company: 'Εταιρεία παραλήπτη',
        delivery_address: 'Διεύθυνση παράδοσης',
        consignee_phone: 'Τηλέφωνο παραλήπτη',
        shipper: 'Αποστολέας',
        shipper_company: 'Εταιρεία αποστολέα',
        address: 'Διεύθυνση',
        country_of_origin: 'Χώρα προέλευσης',
        total_price: 'Συνολική τιμή ($)',
        analysis_rejection_reason: 'Αιτία απόρριψης ανάλυσης',
        export_invoice: 'Εξαγωγή τιμολογίου',
        dhl_confirm_auth: 'Επιβεβαίωση εξουσιοδότησης DHL',
        reject_return_warning:
            'Η απόρριψη της επιστροφής μπορεί να οδηγήσει σε παρακράτηση του ποσού της αξίωσης',
        use_consignee_account_tip:
            'Η χρήση του λογαριασμού του παραλήπτη για αποστολή απαιτεί την εξουσιοδότησή του· παρακαλούμε δώστε το email που θα χρησιμοποιηθεί για την αποστολή',
    },
    // 爱沙尼亚
    etEE: {
        vin: 'VIN',
        claim_information: 'Nõude teave',
        marketing_activity_list: 'Turundustegevuste loend',
        basic_information: 'Põhiteave',
        warranty_block: 'Garantiiblokk',
        repair_block_code: 'Remondibloki kood',
        claim_cycle_list: 'Nõude tsüklite loend',
        WTY_Indicates_the_cycle_type: 'WTY-tsükli tüüp',
        start_time: 'Algusaeg',
        end_time: 'Lõpuaeg',
        WTY_mileage: 'WTY läbisõit',
        List_of_claims: 'Nõudeloend',
        customer: 'Klient',
        warranty_claim: 'Garantiinõue',
        work_order: 'Töökorraldus',
        date_of_receipt: 'Vastuvõtmise kuupäev',
        maintenance_technical_date: 'Hoolduse tehniline kuupäev',
        mileage: 'Läbisõit',
        state: 'Olek',
        main_component: 'Peamine komponent',
        part_name: 'Osa nimi',
        Recall_and_service_activities: 'Tagasikutsumise ja teenindustegevused',
        recall_and_service_activity_code: 'Tagasikutsumise ja teenindustegevuse kood',
        recall_and_service_activity_names: 'Tagasikutsumise ja teenindustegevuste nimed',
        brand: 'Bränd',
        recall_type_code: 'Teenuse tüübi kood',
        recall_type_name: 'Teenuse tüübi nimi',
        release_date: 'Väljalaske kuupäev',
        closing_date: 'Sulgemise kuupäev',
        complete: 'Lõpetatud',
        warranty_claim_status: 'Garantiinõude olek',
        end_of_maintenance_date: 'Hoolduse lõpukuupäev',
        marketing_activity_code: 'Turundustegevuse kood',
        marketing_activity_name: 'Turundustegevuse nimi',
        vehicle_warranty_period: 'Sõiduki garantii periood',
        marketing_activities: 'Turundustegevused',
        prohibition_of_claims: 'Nõudete keeld',
        prohibited_claim_code: 'Keelatud nõude kood',
        type_of_warranty_period: 'Garantiiperioodi tüüp',
        repair_end_date: 'Remondi lõpukuupäev',
        reception_date: 'Vastuvõtmise kuupäev',
        main_station_code: 'Peajaama kood',
        main_workstation_name: 'Peatöökoha nimi',
        smvp_initiator: 'SMVP algataja',
        contact_email: 'SMVP-i kontaktmeil',
        ssnw_doc_no: 'SSNW dokumendi number',
        gws_doc_no: 'GWS dokumendi number',
        missing_doc_reason: 'Dokumendinumbri puudumise põhjus',
        part_return_no: 'Osa tagastamise number',
        part_price: 'Osa hind ($)',
        return_info: 'Tagastusteave',
        add_part: 'Lisa osa',
        initiate_part_return: 'Alusta osa tagastamist',
        domestic_return_form: 'Sisemaa tagastusvorm',
        confirm_part_received: 'Kinnita osa vastuvõtt',
        submit_analysis_report: 'Esita analüüsi aruanne',
        fill_domestic_return_form: 'Täida sisemaa tagastusvorm',
        view_overseas_return_info: 'Vaata välismaa tagastusteavet',
        confirm_domestic_part_return: 'Kinnita sisemaa osa tagastus',
        issue: 'Väljastamine',
        fill_overseas_return_form: 'Täida välismaa tagastusvorm',
        confirm_overseas_part_return: 'Kinnita välismaa osa tagastus',
        view_overseas_return_form: 'Vaata välismaa tagastusvormi',
        reject_reason: 'Tagasilükkamise põhjus',
        choose_part: 'Vali osa',
        express_tracking_number: 'Ekspressi jälgimisnumber',
        auditor: 'Auditor',
        recipient: 'Saaja',
        pickup_date: 'Kullerteenuse ülevõtmise kuupäev',
        consignee: 'Saaja',
        consignee_company: 'Saaja ettevõte',
        delivery_address: 'Tarneaadress',
        consignee_phone: 'Saaja telefon',
        shipper: 'Saatja',
        shipper_company: 'Saatja ettevõte',
        address: 'Aadress',
        country_of_origin: 'Päritolumaa',
        total_price: 'Koguhind ($)',
        analysis_rejection_reason: 'Analüüsi tagasilükkamise põhjus',
        export_invoice: 'Ekspordi arve',
        dhl_confirm_auth: 'DHL-i volituse kinnitus',
        reject_return_warning: 'Tagastuse tagasilükkamine võib põhjustada nõude summa mahaarvamise',
        use_consignee_account_tip:
            'Saaja konto kasutamine saatmiseks nõuab nende volitust; palun esitage saatmiseks kasutatav meiliaadress',
    },
    // 哈萨克
    kkKZ: {
        vin: 'VIN',
        claim_information: 'Талап ақпараты',
        marketing_activity_list: 'Маркетингтік шаралар тізімі',
        basic_information: 'Негізгі ақпарат',
        warranty_block: 'Кепілдік блогы',
        repair_block_code: 'Жөндеу блогының коды',
        claim_cycle_list: 'Талаптар циклының тізімі',
        WTY_Indicates_the_cycle_type: 'WTY циклының түрі',
        start_time: 'Басталу уақыты',
        end_time: 'Аяқталу уақыты',
        WTY_mileage: 'WTY жүрілген жолы',
        List_of_claims: 'Талаптар тізімі',
        customer: 'Тұтынушы',
        warranty_claim: 'Кепілдік талабы',
        work_order: 'Жұмыс тапсырысы',
        date_of_receipt: 'Қабылдау күні',
        maintenance_technical_date: 'Техникалық қызмет көрсету күні',
        mileage: 'Жүрілген жолы',
        state: 'Күйі',
        main_component: 'Негізгі бөлік',
        part_name: 'Бөлшек атауы',
        Recall_and_service_activities: 'Ескертпе және қызмет көрсету шаралары',
        recall_and_service_activity_code: 'Ескертпе және қызмет көрсету шарасының коды',
        recall_and_service_activity_names: 'Ескертпе және қызмет көрсету шараларының атаулары',
        brand: 'Бренд',
        recall_type_code: 'Қызмет түрінің коды',
        recall_type_name: 'Қызмет түрінің атауы',
        release_date: 'Шығарылған күні',
        closing_date: 'Жабылу күні',
        complete: 'Аяқталды',
        warranty_claim_status: 'Кепілдік талабының күйі',
        end_of_maintenance_date: 'Қызмет көрсетудің аяқталу күні',
        marketing_activity_code: 'Маркетингтік шара коды',
        marketing_activity_name: 'Маркетингтік шара атауы',
        vehicle_warranty_period: 'Көліктің кепілдік мерзімі',
        marketing_activities: 'Маркетингтік шаралар',
        prohibition_of_claims: 'Талаптарды тыйым салу',
        prohibited_claim_code: 'Тыйым салынған талап коды',
        type_of_warranty_period: 'Кепілдік мерзімінің түрі',
        repair_end_date: 'Жөндеудің аяқталу күні',
        reception_date: 'Қабылдау күні',
        main_station_code: 'Негізгі станция коды',
        main_workstation_name: 'Негізгі жұмыс орнының атауы',
        smvp_initiator: 'SMVP бастамашысы',
        contact_email: 'SMVP байланыс электрондық поштасы',
        ssnw_doc_no: 'SSNW құжат нөмірі',
        gws_doc_no: 'GWS құжат нөмірі',
        missing_doc_reason: 'Құжат нөмірінің жоқ болу себебі',
        part_return_no: 'Бөлшекті қайтару нөмірі',
        part_price: 'Бөлшек бағасы ($)',
        return_info: 'Қайтару ақпараты',
        add_part: 'Бөлшек қосу',
        initiate_part_return: 'Бөлшекті қайтаруды бастау',
        domestic_return_form: 'Ішкі қайтару форма',
        confirm_part_received: 'Бөлшекті алғанын растау',
        submit_analysis_report: 'Талдау есебін жіберу',
        fill_domestic_return_form: 'Ішкі қайтару формасын толтыру',
        view_overseas_return_info: 'Шетелден қайтару ақпаратын қарау',
        confirm_domestic_part_return: 'Ішкі бөлшекті қайтаруды растау',
        issue: 'Беру',
        fill_overseas_return_form: 'Шетелден қайтару формасын толтыру',
        confirm_overseas_part_return: 'Бөлшекті қайтаруды растау',
        view_overseas_return_form: 'Шетелден қайтару формасын қарау',
        reject_reason: 'Қайтару себебі',
        choose_part: 'Бөлшек таңдау',
        express_tracking_number: 'Экспресс жіберу нөмірі',
        auditor: 'Аудитор',
        recipient: 'Алушы',
        pickup_date: 'Курьердің алатын күні',
        consignee: 'Алушы',
        consignee_company: 'Алушы компаниясы',
        delivery_address: 'Жеткізу мекенжайы',
        consignee_phone: 'Алушының телефоны',
        shipper: 'Жіберуші',
        shipper_company: 'Жіберуші компаниясы',
        address: 'Мекенжайы',
        country_of_origin: 'Шығу елі',
        total_price: 'Жалпы баға ($)',
        analysis_rejection_reason: 'Талдауды қабылдамау себебі',
        export_invoice: 'Шот-фактураны экспорттау',
        dhl_confirm_auth: 'DHL рұқсатын растау',
        reject_return_warning: 'Қайтарудан бас тарту талап соммасынан алып тастауға әкелуі мүмкін',
        use_consignee_account_tip:
            'Жіберу үшін алушының тіркелгісін пайдалану олардың рұқсатын қажет етеді; жіберу үшін қолданылатын электрондық поштаны көрсетіңіз',
    },
    // 希伯来语
    heIL: {
        vin: 'VIN',
        claim_information: 'פרטי תביעה',
        marketing_activity_list: 'רשימת פעילויות שיווק',
        basic_information: 'מידע בסיסי',
        warranty_block: 'בלוק אחריות',
        repair_block_code: 'קוד בלוק תיקון',
        claim_cycle_list: 'רשימת מחזורי תביעות',
        WTY_Indicates_the_cycle_type: 'סוג מחזור WTY',
        start_time: 'שעת התחלה',
        end_time: 'שעת סיום',
        WTY_mileage: 'קילומטרז‘ WTY',
        List_of_claims: 'רשימת תביעות',
        customer: 'לקוח',
        warranty_claim: 'תביעה באחריות',
        work_order: 'פקודת עבודה',
        date_of_receipt: 'תאריך קבלה',
        maintenance_technical_date: 'תאריך טכני של תחזוקה',
        mileage: 'קילומטרז‘',
        state: 'סטטוס',
        main_component: 'רכיב ראשי',
        part_name: 'שם החלק',
        Recall_and_service_activities: 'פעילויות משיכת מוצר ושירות',
        recall_and_service_activity_code: 'קוד פעילות משיכת מוצר ושירות',
        recall_and_service_activity_names: 'שמות פעילויות משיכת מוצר ושירות',
        brand: 'מותג',
        recall_type_code: 'קוד סוג שירות',
        recall_type_name: 'שם סוג שירות',
        release_date: 'תאריך שחרור',
        closing_date: 'תאריך סגירה',
        complete: 'הושלם',
        warranty_claim_status: 'סטטוס תביעת אחריות',
        end_of_maintenance_date: 'תאריך סיום תחזוקה',
        marketing_activity_code: 'קוד פעילות שיווק',
        marketing_activity_name: 'שם פעילות שיווק',
        vehicle_warranty_period: 'תקופת האחריות של הרכב',
        marketing_activities: 'פעילויות שיווק',
        prohibition_of_claims: 'איסור תביעות',
        prohibited_claim_code: 'קוד תביעה אסורה',
        type_of_warranty_period: 'סוג תקופת אחריות',
        repair_end_date: 'תאריך סיום תיקון',
        reception_date: 'תאריך קליטה',
        main_station_code: 'קוד תחנה ראשית',
        main_workstation_name: 'שם תחנה ראשית',
        smvp_initiator: 'יוזם SMVP',
        contact_email: 'דוא"ל יצירת קשר של SMVP',
        ssnw_doc_no: 'מספר מסמך SSNW',
        gws_doc_no: 'מספר מסמך GWS',
        missing_doc_reason: 'סיבת חוסר מספר המסמך',
        part_return_no: 'מספר החזרת חלק',
        part_price: 'מחיר החלק ($)',
        return_info: 'פרטי החזרה',
        add_part: 'הוסף חלק',
        initiate_part_return: 'אתחל החזרת חלק',
        domestic_return_form: 'טופס החזרה מקומית',
        confirm_part_received: 'אשר קבלת החלק',
        submit_analysis_report: 'שלח דוח ניתוח',
        fill_domestic_return_form: 'מלא טופס החזרה מקומית',
        view_overseas_return_info: 'צפה במידע על החזרה בינלאומית',
        confirm_domestic_part_return: 'אשר החזרת חלק מקומית',
        issue: 'הנפק',
        fill_overseas_return_form: 'מלא טופס החזרה בינלאומית',
        confirm_overseas_part_return: 'אשר החזרת חלק',
        view_overseas_return_form: 'צפה בטופס החזרה בינלאומית',
        reject_reason: 'סיבת דחייה',
        choose_part: 'בחר חלק',
        express_tracking_number: 'מספר מעקב של חברת משלוחים',
        auditor: 'מבקר',
        recipient: 'נמען',
        pickup_date: 'תאריך איסוף המשלוח על ידי חברת משלוחים',
        consignee: 'נמען',
        consignee_company: 'חברת הנמען',
        delivery_address: 'כתובת למשלוח',
        consignee_phone: 'טלפון הנמען',
        shipper: 'שולח',
        shipper_company: 'חברת השולח',
        address: 'כתובת',
        country_of_origin: 'מדינת המוצא',
        total_price: 'סה"כ מחיר ($)',
        analysis_rejection_reason: 'סיבת דחיית תוצאת הניתוח',
        export_invoice: 'ייצא חשבונית',
        dhl_confirm_auth: 'אישור הרשאה מ-DHL',
        reject_return_warning: 'דחיית ההחזרה עשויה להוביל להפחתת סכום התביעה',
        use_consignee_account_tip:
            'שימוש בחשבון הנמען למשלוח דורש את הסכמתו; אנא ספק את כתובת הדוא"ל לשימוש למשלוח',
    },
};
